function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import t, { useRef as e, useCallback as n, useState as r, useEffect as a } from "react";
function o(t, e) {
  return t(e = {
    exports: {}
  }, e.exports), e.exports;
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
}
var i = "function" == typeof Symbol && Symbol.for,
  u = i ? Symbol.for("react.element") : 60103,
  l = i ? Symbol.for("react.portal") : 60106,
  c = i ? Symbol.for("react.fragment") : 60107,
  f = i ? Symbol.for("react.strict_mode") : 60108,
  s = i ? Symbol.for("react.profiler") : 60114,
  y = i ? Symbol.for("react.provider") : 60109,
  h = i ? Symbol.for("react.context") : 60110,
  p = i ? Symbol.for("react.async_mode") : 60111,
  d = i ? Symbol.for("react.concurrent_mode") : 60111,
  m = i ? Symbol.for("react.forward_ref") : 60112,
  g = i ? Symbol.for("react.suspense") : 60113,
  b = i ? Symbol.for("react.suspense_list") : 60120,
  v = i ? Symbol.for("react.memo") : 60115,
  C = i ? Symbol.for("react.lazy") : 60116,
  O = i ? Symbol.for("react.block") : 60121,
  N = i ? Symbol.for("react.fundamental") : 60117,
  w = i ? Symbol.for("react.responder") : 60118,
  P = i ? Symbol.for("react.scope") : 60119;
function x(t) {
  if ("object" == _typeof(t) && null !== t) {
    var e = t.$$typeof;
    switch (e) {
      case u:
        switch (t = t.type) {
          case p:
          case d:
          case c:
          case s:
          case f:
          case g:
            return t;
          default:
            switch (t = t && t.$$typeof) {
              case h:
              case m:
              case C:
              case v:
              case y:
                return t;
              default:
                return e;
            }
        }
      case l:
        return e;
    }
  }
}
function S(t) {
  return x(t) === d;
}
var j = {
    AsyncMode: p,
    ConcurrentMode: d,
    ContextConsumer: h,
    ContextProvider: y,
    Element: u,
    ForwardRef: m,
    Fragment: c,
    Lazy: C,
    Memo: v,
    Portal: l,
    Profiler: s,
    StrictMode: f,
    Suspense: g,
    isAsyncMode: function isAsyncMode(t) {
      return S(t) || x(t) === p;
    },
    isConcurrentMode: S,
    isContextConsumer: function isContextConsumer(t) {
      return x(t) === h;
    },
    isContextProvider: function isContextProvider(t) {
      return x(t) === y;
    },
    isElement: function isElement(t) {
      return "object" == _typeof(t) && null !== t && t.$$typeof === u;
    },
    isForwardRef: function isForwardRef(t) {
      return x(t) === m;
    },
    isFragment: function isFragment(t) {
      return x(t) === c;
    },
    isLazy: function isLazy(t) {
      return x(t) === C;
    },
    isMemo: function isMemo(t) {
      return x(t) === v;
    },
    isPortal: function isPortal(t) {
      return x(t) === l;
    },
    isProfiler: function isProfiler(t) {
      return x(t) === s;
    },
    isStrictMode: function isStrictMode(t) {
      return x(t) === f;
    },
    isSuspense: function isSuspense(t) {
      return x(t) === g;
    },
    isValidElementType: function isValidElementType(t) {
      return "string" == typeof t || "function" == typeof t || t === c || t === d || t === s || t === f || t === g || t === b || "object" == _typeof(t) && null !== t && (t.$$typeof === C || t.$$typeof === v || t.$$typeof === y || t.$$typeof === h || t.$$typeof === m || t.$$typeof === N || t.$$typeof === w || t.$$typeof === P || t.$$typeof === O);
    },
    typeOf: x
  },
  E = o(function (t, e) {
    "production" !== process.env.NODE_ENV && function () {
      var t = "function" == typeof Symbol && Symbol.for,
        n = t ? Symbol.for("react.element") : 60103,
        r = t ? Symbol.for("react.portal") : 60106,
        a = t ? Symbol.for("react.fragment") : 60107,
        o = t ? Symbol.for("react.strict_mode") : 60108,
        i = t ? Symbol.for("react.profiler") : 60114,
        u = t ? Symbol.for("react.provider") : 60109,
        l = t ? Symbol.for("react.context") : 60110,
        c = t ? Symbol.for("react.async_mode") : 60111,
        f = t ? Symbol.for("react.concurrent_mode") : 60111,
        s = t ? Symbol.for("react.forward_ref") : 60112,
        y = t ? Symbol.for("react.suspense") : 60113,
        h = t ? Symbol.for("react.suspense_list") : 60120,
        p = t ? Symbol.for("react.memo") : 60115,
        d = t ? Symbol.for("react.lazy") : 60116,
        m = t ? Symbol.for("react.block") : 60121,
        g = t ? Symbol.for("react.fundamental") : 60117,
        b = t ? Symbol.for("react.responder") : 60118,
        v = t ? Symbol.for("react.scope") : 60119;
      function C(t) {
        if ("object" == _typeof(t) && null !== t) {
          var e = t.$$typeof;
          switch (e) {
            case n:
              var h = t.type;
              switch (h) {
                case c:
                case f:
                case a:
                case i:
                case o:
                case y:
                  return h;
                default:
                  var m = h && h.$$typeof;
                  switch (m) {
                    case l:
                    case s:
                    case d:
                    case p:
                    case u:
                      return m;
                    default:
                      return e;
                  }
              }
            case r:
              return e;
          }
        }
      }
      var O = c,
        N = f,
        w = l,
        P = u,
        x = n,
        S = s,
        j = a,
        E = d,
        I = p,
        k = r,
        A = i,
        T = o,
        F = y,
        D = !1;
      function R(t) {
        return C(t) === f;
      }
      e.AsyncMode = O, e.ConcurrentMode = N, e.ContextConsumer = w, e.ContextProvider = P, e.Element = x, e.ForwardRef = S, e.Fragment = j, e.Lazy = E, e.Memo = I, e.Portal = k, e.Profiler = A, e.StrictMode = T, e.Suspense = F, e.isAsyncMode = function (t) {
        return D || (D = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), R(t) || C(t) === c;
      }, e.isConcurrentMode = R, e.isContextConsumer = function (t) {
        return C(t) === l;
      }, e.isContextProvider = function (t) {
        return C(t) === u;
      }, e.isElement = function (t) {
        return "object" == _typeof(t) && null !== t && t.$$typeof === n;
      }, e.isForwardRef = function (t) {
        return C(t) === s;
      }, e.isFragment = function (t) {
        return C(t) === a;
      }, e.isLazy = function (t) {
        return C(t) === d;
      }, e.isMemo = function (t) {
        return C(t) === p;
      }, e.isPortal = function (t) {
        return C(t) === r;
      }, e.isProfiler = function (t) {
        return C(t) === i;
      }, e.isStrictMode = function (t) {
        return C(t) === o;
      }, e.isSuspense = function (t) {
        return C(t) === y;
      }, e.isValidElementType = function (t) {
        return "string" == typeof t || "function" == typeof t || t === a || t === f || t === i || t === o || t === y || t === h || "object" == _typeof(t) && null !== t && (t.$$typeof === d || t.$$typeof === p || t.$$typeof === u || t.$$typeof === l || t.$$typeof === s || t.$$typeof === g || t.$$typeof === b || t.$$typeof === v || t.$$typeof === m);
      }, e.typeOf = C;
    }();
  });
E.AsyncMode, E.ConcurrentMode, E.ContextConsumer, E.ContextProvider, E.Element, E.ForwardRef, E.Fragment, E.Lazy, E.Memo, E.Portal, E.Profiler, E.StrictMode, E.Suspense, E.isAsyncMode, E.isConcurrentMode, E.isContextConsumer, E.isContextProvider, E.isElement, E.isForwardRef, E.isFragment, E.isLazy, E.isMemo, E.isPortal, E.isProfiler, E.isStrictMode, E.isSuspense, E.isValidElementType, E.typeOf;
var I = o(function (t) {
    "production" === process.env.NODE_ENV ? t.exports = j : t.exports = E;
  }),
  k = Object.getOwnPropertySymbols,
  A = Object.prototype.hasOwnProperty,
  T = Object.prototype.propertyIsEnumerable;
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var F = function () {
    try {
      if (!Object.assign) return !1;
      var t = new String("abc");
      if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;
      for (var e = {}, n = 0; n < 10; n++) e["_" + String.fromCharCode(n)] = n;
      var r = Object.getOwnPropertyNames(e).map(function (t) {
        return e[t];
      });
      if ("0123456789" !== r.join("")) return !1;
      var a = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (t) {
        a[t] = t;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, a)).join("");
    } catch (t) {
      return !1;
    }
  }() ? Object.assign : function (t, e) {
    for (var n, r, a = function (t) {
        if (null == t) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(t);
      }(t), o = 1; o < arguments.length; o++) {
      for (var i in n = Object(arguments[o])) A.call(n, i) && (a[i] = n[i]);
      if (k) {
        r = k(n);
        for (var u = 0; u < r.length; u++) T.call(n, r[u]) && (a[r[u]] = n[r[u]]);
      }
    }
    return a;
  },
  D = Function.call.bind(Object.prototype.hasOwnProperty),
  R = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
  _ = D,
  M = function M() {};
if ("production" !== process.env.NODE_ENV) {
  var $ = R,
    L = {},
    U = _;
  M = function M(t) {
    var e = "Warning: " + t;
    "undefined" != typeof console && console.error(e);
    try {
      throw new Error(e);
    } catch (t) {}
  };
}
function B(t, e, n, r, a) {
  if ("production" !== process.env.NODE_ENV) for (var o in t) if (U(t, o)) {
    var i;
    try {
      if ("function" != typeof t[o]) {
        var u = Error((r || "React class") + ": " + n + " type `" + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + _typeof(t[o]) + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
        throw u.name = "Invariant Violation", u;
      }
      i = t[o](e, o, r, n, null, $);
    } catch (t) {
      i = t;
    }
    if (!i || i instanceof Error || M((r || "React class") + ": type specification of " + n + " `" + o + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + _typeof(i) + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), i instanceof Error && !(i.message in L)) {
      L[i.message] = !0;
      var l = a ? a() : "";
      M("Failed " + n + " type: " + i.message + (null != l ? l : ""));
    }
  }
}
B.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (L = {});
};
var V = B,
  W = function W() {};
function G() {
  return null;
}
"production" !== process.env.NODE_ENV && (W = function W(t) {
  var e = "Warning: " + t;
  "undefined" != typeof console && console.error(e);
  try {
    throw new Error(e);
  } catch (t) {}
});
function q() {}
function H() {}
H.resetWarningCache = q;
var z = function z(t, e) {
    var n = "function" == typeof Symbol && Symbol.iterator,
      r = "@@iterator";
    var a = "<<anonymous>>",
      o = {
        array: c("array"),
        bigint: c("bigint"),
        bool: c("boolean"),
        func: c("function"),
        number: c("number"),
        object: c("object"),
        string: c("string"),
        symbol: c("symbol"),
        any: l(G),
        arrayOf: function arrayOf(t) {
          return l(function (e, n, r, a, o) {
            if ("function" != typeof t) return new u("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
            var i = e[n];
            if (!Array.isArray(i)) return new u("Invalid " + a + " `" + o + "` of type `" + y(i) + "` supplied to `" + r + "`, expected an array.");
            for (var l = 0; l < i.length; l++) {
              var c = t(i, l, r, a, o + "[" + l + "]", R);
              if (c instanceof Error) return c;
            }
            return null;
          });
        },
        element: l(function (e, n, r, a, o) {
          var i = e[n];
          return t(i) ? null : new u("Invalid " + a + " `" + o + "` of type `" + y(i) + "` supplied to `" + r + "`, expected a single ReactElement.");
        }),
        elementType: l(function (t, e, n, r, a) {
          var o = t[e];
          return I.isValidElementType(o) ? null : new u("Invalid " + r + " `" + a + "` of type `" + y(o) + "` supplied to `" + n + "`, expected a single ReactElement type.");
        }),
        instanceOf: function instanceOf(t) {
          return l(function (e, n, r, o, i) {
            if (!(e[n] instanceof t)) {
              var l = t.name || a;
              return new u("Invalid " + o + " `" + i + "` of type `" + (((c = e[n]).constructor && c.constructor.name ? c.constructor.name : a) + "` supplied to `") + r + "`, expected instance of `" + l + "`.");
            }
            var c;
            return null;
          });
        },
        node: l(function (t, e, n, r, a) {
          return s(t[e]) ? null : new u("Invalid " + r + " `" + a + "` supplied to `" + n + "`, expected a ReactNode.");
        }),
        objectOf: function objectOf(t) {
          return l(function (e, n, r, a, o) {
            if ("function" != typeof t) return new u("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
            var i = e[n],
              l = y(i);
            if ("object" !== l) return new u("Invalid " + a + " `" + o + "` of type `" + l + "` supplied to `" + r + "`, expected an object.");
            for (var c in i) if (_(i, c)) {
              var f = t(i, c, r, a, o + "." + c, R);
              if (f instanceof Error) return f;
            }
            return null;
          });
        },
        oneOf: function oneOf(t) {
          if (!Array.isArray(t)) return "production" !== process.env.NODE_ENV && W(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), G;
          return l(function (e, n, r, a, o) {
            for (var l = e[n], c = 0; c < t.length; c++) if (i(l, t[c])) return null;
            var f = JSON.stringify(t, function (t, e) {
              return "symbol" === h(e) ? String(e) : e;
            });
            return new u("Invalid " + a + " `" + o + "` of value `" + String(l) + "` supplied to `" + r + "`, expected one of " + f + ".");
          });
        },
        oneOfType: function oneOfType(t) {
          if (!Array.isArray(t)) return "production" !== process.env.NODE_ENV && W("Invalid argument supplied to oneOfType, expected an instance of array."), G;
          for (var e = 0; e < t.length; e++) {
            var n = t[e];
            if ("function" != typeof n) return W("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + p(n) + " at index " + e + "."), G;
          }
          return l(function (e, n, r, a, o) {
            for (var i = [], l = 0; l < t.length; l++) {
              var c = (0, t[l])(e, n, r, a, o, R);
              if (null == c) return null;
              c.data && _(c.data, "expectedType") && i.push(c.data.expectedType);
            }
            return new u("Invalid " + a + " `" + o + "` supplied to `" + r + "`" + (i.length > 0 ? ", expected one of type [" + i.join(", ") + "]" : "") + ".");
          });
        },
        shape: function shape(t) {
          return l(function (e, n, r, a, o) {
            var i = e[n],
              l = y(i);
            if ("object" !== l) return new u("Invalid " + a + " `" + o + "` of type `" + l + "` supplied to `" + r + "`, expected `object`.");
            for (var c in t) {
              var s = t[c];
              if ("function" != typeof s) return f(r, a, o, c, h(s));
              var p = s(i, c, r, a, o + "." + c, R);
              if (p) return p;
            }
            return null;
          });
        },
        exact: function exact(t) {
          return l(function (e, n, r, a, o) {
            var i = e[n],
              l = y(i);
            if ("object" !== l) return new u("Invalid " + a + " `" + o + "` of type `" + l + "` supplied to `" + r + "`, expected `object`.");
            var c = F({}, e[n], t);
            for (var s in c) {
              var p = t[s];
              if (_(t, s) && "function" != typeof p) return f(r, a, o, s, h(p));
              if (!p) return new u("Invalid " + a + " `" + o + "` key `" + s + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(e[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(t), null, "  "));
              var d = p(i, s, r, a, o + "." + s, R);
              if (d) return d;
            }
            return null;
          });
        }
      };
    function i(t, e) {
      return t === e ? 0 !== t || 1 / t == 1 / e : t != t && e != e;
    }
    function u(t, e) {
      this.message = t, this.data = e && "object" == _typeof(e) ? e : {}, this.stack = "";
    }
    function l(t) {
      if ("production" !== process.env.NODE_ENV) var n = {},
        r = 0;
      function o(o, i, l, c, f, s, y) {
        if (c = c || a, s = s || l, y !== R) {
          if (e) {
            var h = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw h.name = "Invariant Violation", h;
          }
          if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
            var p = c + ":" + l;
            !n[p] && r < 3 && (W("You are manually calling a React.PropTypes validation function for the `" + s + "` prop on `" + c + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[p] = !0, r++);
          }
        }
        return null == i[l] ? o ? null === i[l] ? new u("The " + f + " `" + s + "` is marked as required in `" + c + "`, but its value is `null`.") : new u("The " + f + " `" + s + "` is marked as required in `" + c + "`, but its value is `undefined`.") : null : t(i, l, c, f, s);
      }
      var i = o.bind(null, !1);
      return i.isRequired = o.bind(null, !0), i;
    }
    function c(t) {
      return l(function (e, n, r, a, o, i) {
        var l = e[n];
        return y(l) !== t ? new u("Invalid " + a + " `" + o + "` of type `" + h(l) + "` supplied to `" + r + "`, expected `" + t + "`.", {
          expectedType: t
        }) : null;
      });
    }
    function f(t, e, n, r, a) {
      return new u((t || "React class") + ": " + e + " type `" + n + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + a + "`.");
    }
    function s(e) {
      switch (_typeof(e)) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !e;
        case "object":
          if (Array.isArray(e)) return e.every(s);
          if (null === e || t(e)) return !0;
          var a = function (t) {
            var e = t && (n && t[n] || t[r]);
            if ("function" == typeof e) return e;
          }(e);
          if (!a) return !1;
          var o,
            i = a.call(e);
          if (a !== e.entries) {
            for (; !(o = i.next()).done;) if (!s(o.value)) return !1;
          } else for (; !(o = i.next()).done;) {
            var u = o.value;
            if (u && !s(u[1])) return !1;
          }
          return !0;
        default:
          return !1;
      }
    }
    function y(t) {
      var e = _typeof(t);
      return Array.isArray(t) ? "array" : t instanceof RegExp ? "object" : function (t, e) {
        return "symbol" === t || !!e && ("Symbol" === e["@@toStringTag"] || "function" == typeof Symbol && e instanceof Symbol);
      }(e, t) ? "symbol" : e;
    }
    function h(t) {
      if (null == t) return "" + t;
      var e = y(t);
      if ("object" === e) {
        if (t instanceof Date) return "date";
        if (t instanceof RegExp) return "regexp";
      }
      return e;
    }
    function p(t) {
      var e = h(t);
      switch (e) {
        case "array":
        case "object":
          return "an " + e;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + e;
        default:
          return e;
      }
    }
    return u.prototype = Error.prototype, o.checkPropTypes = V, o.resetWarningCache = V.resetWarningCache, o.PropTypes = o, o;
  },
  X = function X() {
    function t(t, e, n, r, a, o) {
      if (o !== R) {
        var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw i.name = "Invariant Violation", i;
      }
    }
    function e() {
      return t;
    }
    t.isRequired = t;
    var n = {
      array: t,
      bigint: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: e,
      element: t,
      elementType: t,
      instanceOf: e,
      node: t,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e,
      checkPropTypes: H,
      resetWarningCache: q
    };
    return n.PropTypes = n, n;
  },
  Y = o(function (t) {
    if ("production" !== process.env.NODE_ENV) {
      var e = I;
      t.exports = z(e.isElement, !0);
    } else t.exports = X();
  });
function J(t, e) {
  var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return K(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === n && t.constructor && (n = t.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(t);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return K(t, e);
  }(t)) || e && t && "number" == typeof t.length) {
    n && (t = n);
    var r = 0;
    return function () {
      return r >= t.length ? {
        done: !0
      } : {
        done: !1,
        value: t[r++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function K(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function Z(t, e) {
  for (var n, r = 0, a = J(e.split("")); !(n = a()).done;) {
    n.value === t && r++;
  }
  return r;
}
function Q(t, e) {
  var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return tt(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === n && t.constructor && (n = t.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(t);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tt(t, e);
  }(t)) || e && t && "number" == typeof t.length) {
    n && (t = n);
    var r = 0;
    return function () {
      return r >= t.length ? {
        done: !0
      } : {
        done: !1,
        value: t[r++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function tt(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function et(t) {
  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "x",
    n = arguments.length > 2 ? arguments[2] : void 0;
  if (!t) return function (t) {
    return {
      text: t
    };
  };
  var r = Z(e, t);
  return function (a) {
    if (!a) return {
      text: "",
      template: t
    };
    for (var o, i = 0, u = "", l = Q(t.split("")); !(o = l()).done;) {
      var c = o.value;
      if (c === e) {
        if (u += a[i], ++i === a.length && a.length < r) break;
      } else u += c;
    }
    return n && (u = function (t, e) {
      for (var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "x", r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : " ", a = t.length, o = Z("(", t) - Z(")", t); o > 0 && a < e.length;) t += e[a].replace(n, r), ")" === e[a] && o--, a++;
      return t;
    }(u, t)), {
      text: u,
      template: t
    };
  };
}
var nt = {
  Backspace: 8,
  Delete: 46
};
function rt(t, e) {
  void 0 !== e && (!function () {
    if ("undefined" != typeof navigator) return at.test(navigator.userAgent);
  }() ? t.setSelectionRange(e, e) : setTimeout(function () {
    return t.setSelectionRange(e, e);
  }, 0));
}
var at = /Android/i;
function ot(t, e, n, r, a) {
  if (!e.hasAttribute("readonly")) {
    var o = function (t) {
      switch (t.keyCode) {
        case nt.Backspace:
          return "Backspace";
        case nt.Delete:
          return "Delete";
      }
    }(t);
    switch (o) {
      case "Delete":
      case "Backspace":
        t.preventDefault();
        var i = function (t) {
          if (t.selectionStart !== t.selectionEnd) return {
            start: t.selectionStart,
            end: t.selectionEnd
          };
        }(e);
        return i ? (function (t, e) {
          var n = t.value;
          n = n.slice(0, e.start) + n.slice(e.end), t.value = n, rt(t, e.start);
        }(e, i), it(e, n, r, void 0, a)) : it(e, n, r, o, a);
    }
  }
}
function it(t, e, n, r, a) {
  var o = function (t, e, n) {
      for (var r = "", a = 0, o = 0; o < t.length;) {
        var i = n(t[o], r);
        void 0 !== i && (r += i, void 0 !== e && (e === o ? a = r.length - 1 : e > o && (a = r.length))), o++;
      }
      return void 0 === e && (a = r.length), {
        value: r,
        caret: a
      };
    }(t.value, t.selectionStart, e),
    i = o.value,
    u = o.caret;
  if (r) {
    var l = function (t, e, n) {
      switch (n) {
        case "Backspace":
          e > 0 && (t = t.slice(0, e - 1) + t.slice(e), e--);
          break;
        case "Delete":
          t = t.slice(0, e) + t.slice(e + 1);
      }
      return {
        value: t,
        caret: e
      };
    }(i, u, r);
    i = l.value, u = l.caret;
  }
  var c = function (t, e, n) {
      "string" == typeof n && (n = et(n));
      var r = n(t) || {},
        a = r.text,
        o = r.template;
      if (void 0 === a && (a = t), o) if (void 0 === e) e = a.length;else {
        for (var i = 0, u = !1, l = -1; i < a.length && i < o.length;) {
          if (a[i] !== o[i]) {
            if (0 === e) {
              u = !0, e = i;
              break;
            }
            l = i, e--;
          }
          i++;
        }
        u || (e = l + 1);
      }
      return {
        text: a,
        caret: e
      };
    }(i, u, n),
    f = c.text;
  u = c.caret, t.value = f, rt(t, u), a(i);
}
var ut = ["value", "parse", "format", "inputComponent", "onChange", "onKeyDown"];
function lt() {
  return lt = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, lt.apply(this, arguments);
}
function ct(t, e) {
  if (null == t) return {};
  var n,
    r,
    a = function (t, e) {
      if (null == t) return {};
      var n,
        r,
        a = {},
        o = Object.keys(t);
      for (r = 0; r < o.length; r++) n = o[r], e.indexOf(n) >= 0 || (a[n] = t[n]);
      return a;
    }(t, e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (r = 0; r < o.length; r++) n = o[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (a[n] = t[n]);
  }
  return a;
}
function ft(r, a) {
  var o = r.value,
    i = r.parse,
    u = r.format,
    l = r.inputComponent,
    c = r.onChange,
    f = r.onKeyDown,
    s = ct(r, ut),
    y = e(),
    h = n(function (t) {
      y.current = t, a && ("function" == typeof a ? a(t) : a.current = t);
    }, [a]),
    p = n(function (t) {
      it(y.current, i, u, void 0, c);
    }, [y, i, u, c]),
    d = n(function (t) {
      return f && f(t), ot(t, y.current, i, u, c);
    }, [y, i, u, c, f]);
  return /*#__PURE__*/t.createElement(l, lt({}, s, {
    ref: h,
    value: u(yt(o) ? "" : o).text,
    onKeyDown: d,
    onChange: p
  }));
}
(ft = /*#__PURE__*/t.forwardRef(ft)).propTypes = {
  parse: Y.func.isRequired,
  format: Y.func.isRequired,
  inputComponent: Y.elementType.isRequired,
  type: Y.string.isRequired,
  value: Y.string,
  onChange: Y.func.isRequired,
  onKeyDown: Y.func,
  onCut: Y.func,
  onPaste: Y.func
}, ft.defaultProps = {
  inputComponent: "input",
  type: "text"
};
var st = ft;
function yt(t) {
  return null == t;
}
function ht(t) {
  return ht = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
    return _typeof(t);
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
  }, ht(t);
}
function pt(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function dt(t) {
  var e = vt();
  return function () {
    var n,
      r = Ot(t);
    if (e) {
      var a = Ot(this).constructor;
      n = Reflect.construct(r, arguments, a);
    } else n = r.apply(this, arguments);
    return function (t, e) {
      if (e && ("object" === ht(e) || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return mt(t);
    }(this, n);
  };
}
function mt(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function gt(t) {
  var e = "function" == typeof Map ? new Map() : void 0;
  return gt = function gt(t) {
    if (null === t || (n = t, -1 === Function.toString.call(n).indexOf("[native code]"))) return t;
    var n;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== e) {
      if (e.has(t)) return e.get(t);
      e.set(t, r);
    }
    function r() {
      return bt(t, arguments, Ot(this).constructor);
    }
    return r.prototype = Object.create(t.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Ct(r, t);
  }, gt(t);
}
function bt(t, e, n) {
  return bt = vt() ? Reflect.construct : function (t, e, n) {
    var r = [null];
    r.push.apply(r, e);
    var a = new (Function.bind.apply(t, r))();
    return n && Ct(a, n.prototype), a;
  }, bt.apply(null, arguments);
}
function vt() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (t) {
    return !1;
  }
}
function Ct(t, e) {
  return Ct = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  }, Ct(t, e);
}
function Ot(t) {
  return Ot = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Ot(t);
}
var Nt = function (t) {
    !function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(t, "prototype", {
        writable: !1
      }), e && Ct(t, e);
    }(o, gt(Error));
    var e,
      n,
      r,
      a = dt(o);
    function o(t) {
      var e;
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, o), e = a.call(this, t), Object.setPrototypeOf(mt(e), o.prototype), e.name = e.constructor.name, e;
    }
    return e = o, n && pt(e.prototype, n), r && pt(e, r), Object.defineProperty(e, "prototype", {
      writable: !1
    }), e;
  }(),
  wt = 2,
  Pt = 17,
  xt = 3,
  St = "0-9０-９٠-٩۰-۹",
  jt = "".concat("-‐-―−ー－").concat("／/").concat("．.").concat("  ­​⁠　").concat("()（）［］\\[\\]").concat("~⁓∼～");
function Et(t, e) {
  t = t.split("-"), e = e.split("-");
  for (var n = t[0].split("."), r = e[0].split("."), a = 0; a < 3; a++) {
    var o = Number(n[a]),
      i = Number(r[a]);
    if (o > i) return 1;
    if (i > o) return -1;
    if (!isNaN(o) && isNaN(i)) return 1;
    if (isNaN(o) && !isNaN(i)) return -1;
  }
  return t[1] && e[1] ? t[1] > e[1] ? 1 : t[1] < e[1] ? -1 : 0 : !t[1] && e[1] ? 1 : t[1] && !e[1] ? -1 : 0;
}
function It(t) {
  return It = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
    return _typeof(t);
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
  }, It(t);
}
function kt(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function At(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Tt(t, e, n) {
  return e && At(t.prototype, e), n && At(t, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
var Ft = " ext. ",
  Dt = /^\d+$/,
  Rt = function () {
    function t(e) {
      kt(this, t), function (t) {
        if (!t) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
        if (!Bt(t) || !Bt(t.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(Bt(t) ? "an object of shape: { " + Object.keys(t).join(", ") + " }" : "a " + Vt(t) + ": " + t, "."));
      }(e), this.metadata = e, qt.call(this, e);
    }
    return Tt(t, [{
      key: "getCountries",
      value: function value() {
        return Object.keys(this.metadata.countries).filter(function (t) {
          return "001" !== t;
        });
      }
    }, {
      key: "getCountryMetadata",
      value: function value(t) {
        return this.metadata.countries[t];
      }
    }, {
      key: "nonGeographic",
      value: function value() {
        if (!(this.v1 || this.v2 || this.v3)) return this.metadata.nonGeographic || this.metadata.nonGeographical;
      }
    }, {
      key: "hasCountry",
      value: function value(t) {
        return void 0 !== this.getCountryMetadata(t);
      }
    }, {
      key: "hasCallingCode",
      value: function value(t) {
        if (this.getCountryCodesForCallingCode(t)) return !0;
        if (this.nonGeographic()) {
          if (this.nonGeographic()[t]) return !0;
        } else {
          var e = this.countryCallingCodes()[t];
          if (e && 1 === e.length && "001" === e[0]) return !0;
        }
      }
    }, {
      key: "isNonGeographicCallingCode",
      value: function value(t) {
        return this.nonGeographic() ? !!this.nonGeographic()[t] : !this.getCountryCodesForCallingCode(t);
      }
    }, {
      key: "country",
      value: function value(t) {
        return this.selectNumberingPlan(t);
      }
    }, {
      key: "selectNumberingPlan",
      value: function value(t, e) {
        if (t && Dt.test(t) && (e = t, t = null), t && "001" !== t) {
          if (!this.hasCountry(t)) throw new Error("Unknown country: ".concat(t));
          this.numberingPlan = new _t(this.getCountryMetadata(t), this);
        } else if (e) {
          if (!this.hasCallingCode(e)) throw new Error("Unknown calling code: ".concat(e));
          this.numberingPlan = new _t(this.getNumberingPlanMetadata(e), this);
        } else this.numberingPlan = void 0;
        return this;
      }
    }, {
      key: "getCountryCodesForCallingCode",
      value: function value(t) {
        var e = this.countryCallingCodes()[t];
        if (e) {
          if (1 === e.length && 3 === e[0].length) return;
          return e;
        }
      }
    }, {
      key: "getCountryCodeForCallingCode",
      value: function value(t) {
        var e = this.getCountryCodesForCallingCode(t);
        if (e) return e[0];
      }
    }, {
      key: "getNumberingPlanMetadata",
      value: function value(t) {
        var e = this.getCountryCodeForCallingCode(t);
        if (e) return this.getCountryMetadata(e);
        if (this.nonGeographic()) {
          var n = this.nonGeographic()[t];
          if (n) return n;
        } else {
          var r = this.countryCallingCodes()[t];
          if (r && 1 === r.length && "001" === r[0]) return this.metadata.countries["001"];
        }
      }
    }, {
      key: "countryCallingCode",
      value: function value() {
        return this.numberingPlan.callingCode();
      }
    }, {
      key: "IDDPrefix",
      value: function value() {
        return this.numberingPlan.IDDPrefix();
      }
    }, {
      key: "defaultIDDPrefix",
      value: function value() {
        return this.numberingPlan.defaultIDDPrefix();
      }
    }, {
      key: "nationalNumberPattern",
      value: function value() {
        return this.numberingPlan.nationalNumberPattern();
      }
    }, {
      key: "possibleLengths",
      value: function value() {
        return this.numberingPlan.possibleLengths();
      }
    }, {
      key: "formats",
      value: function value() {
        return this.numberingPlan.formats();
      }
    }, {
      key: "nationalPrefixForParsing",
      value: function value() {
        return this.numberingPlan.nationalPrefixForParsing();
      }
    }, {
      key: "nationalPrefixTransformRule",
      value: function value() {
        return this.numberingPlan.nationalPrefixTransformRule();
      }
    }, {
      key: "leadingDigits",
      value: function value() {
        return this.numberingPlan.leadingDigits();
      }
    }, {
      key: "hasTypes",
      value: function value() {
        return this.numberingPlan.hasTypes();
      }
    }, {
      key: "type",
      value: function value(t) {
        return this.numberingPlan.type(t);
      }
    }, {
      key: "ext",
      value: function value() {
        return this.numberingPlan.ext();
      }
    }, {
      key: "countryCallingCodes",
      value: function value() {
        return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
      }
    }, {
      key: "chooseCountryByCountryCallingCode",
      value: function value(t) {
        return this.selectNumberingPlan(t);
      }
    }, {
      key: "hasSelectedNumberingPlan",
      value: function value() {
        return void 0 !== this.numberingPlan;
      }
    }]), t;
  }(),
  _t = function () {
    function t(e, n) {
      kt(this, t), this.globalMetadataObject = n, this.metadata = e, qt.call(this, n.metadata);
    }
    return Tt(t, [{
      key: "callingCode",
      value: function value() {
        return this.metadata[0];
      }
    }, {
      key: "getDefaultCountryMetadataForRegion",
      value: function value() {
        return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
      }
    }, {
      key: "IDDPrefix",
      value: function value() {
        if (!this.v1 && !this.v2) return this.metadata[1];
      }
    }, {
      key: "defaultIDDPrefix",
      value: function value() {
        if (!this.v1 && !this.v2) return this.metadata[12];
      }
    }, {
      key: "nationalNumberPattern",
      value: function value() {
        return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
      }
    }, {
      key: "possibleLengths",
      value: function value() {
        if (!this.v1) return this.metadata[this.v2 ? 2 : 3];
      }
    }, {
      key: "_getFormats",
      value: function value(t) {
        return t[this.v1 ? 2 : this.v2 ? 3 : 4];
      }
    }, {
      key: "formats",
      value: function value() {
        var t = this,
          e = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
        return e.map(function (e) {
          return new Mt(e, t);
        });
      }
    }, {
      key: "nationalPrefix",
      value: function value() {
        return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
      }
    }, {
      key: "_getNationalPrefixFormattingRule",
      value: function value(t) {
        return t[this.v1 ? 4 : this.v2 ? 5 : 6];
      }
    }, {
      key: "nationalPrefixFormattingRule",
      value: function value() {
        return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
      }
    }, {
      key: "_nationalPrefixForParsing",
      value: function value() {
        return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
      }
    }, {
      key: "nationalPrefixForParsing",
      value: function value() {
        return this._nationalPrefixForParsing() || this.nationalPrefix();
      }
    }, {
      key: "nationalPrefixTransformRule",
      value: function value() {
        return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
      }
    }, {
      key: "_getNationalPrefixIsOptionalWhenFormatting",
      value: function value() {
        return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
      }
    }, {
      key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
      value: function value() {
        return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
      }
    }, {
      key: "leadingDigits",
      value: function value() {
        return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
      }
    }, {
      key: "types",
      value: function value() {
        return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
      }
    }, {
      key: "hasTypes",
      value: function value() {
        return (!this.types() || 0 !== this.types().length) && !!this.types();
      }
    }, {
      key: "type",
      value: function value(t) {
        if (this.hasTypes() && Ut(this.types(), t)) return new Lt(Ut(this.types(), t), this);
      }
    }, {
      key: "ext",
      value: function value() {
        return this.v1 || this.v2 ? Ft : this.metadata[13] || Ft;
      }
    }]), t;
  }(),
  Mt = function () {
    function t(e, n) {
      kt(this, t), this._format = e, this.metadata = n;
    }
    return Tt(t, [{
      key: "pattern",
      value: function value() {
        return this._format[0];
      }
    }, {
      key: "format",
      value: function value() {
        return this._format[1];
      }
    }, {
      key: "leadingDigitsPatterns",
      value: function value() {
        return this._format[2] || [];
      }
    }, {
      key: "nationalPrefixFormattingRule",
      value: function value() {
        return this._format[3] || this.metadata.nationalPrefixFormattingRule();
      }
    }, {
      key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
      value: function value() {
        return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
      }
    }, {
      key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
      value: function value() {
        return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
      }
    }, {
      key: "usesNationalPrefix",
      value: function value() {
        return !(!this.nationalPrefixFormattingRule() || $t.test(this.nationalPrefixFormattingRule()));
      }
    }, {
      key: "internationalFormat",
      value: function value() {
        return this._format[5] || this.format();
      }
    }]), t;
  }(),
  $t = /^\(?\$1\)?$/,
  Lt = function () {
    function t(e, n) {
      kt(this, t), this.type = e, this.metadata = n;
    }
    return Tt(t, [{
      key: "pattern",
      value: function value() {
        return this.metadata.v1 ? this.type : this.type[0];
      }
    }, {
      key: "possibleLengths",
      value: function value() {
        if (!this.metadata.v1) return this.type[1] || this.metadata.possibleLengths();
      }
    }]), t;
  }();
function Ut(t, e) {
  switch (e) {
    case "FIXED_LINE":
      return t[0];
    case "MOBILE":
      return t[1];
    case "TOLL_FREE":
      return t[2];
    case "PREMIUM_RATE":
      return t[3];
    case "PERSONAL_NUMBER":
      return t[4];
    case "VOICEMAIL":
      return t[5];
    case "UAN":
      return t[6];
    case "PAGER":
      return t[7];
    case "VOIP":
      return t[8];
    case "SHARED_COST":
      return t[9];
  }
}
var Bt = function Bt(t) {
    return "object" === It(t);
  },
  Vt = function Vt(t) {
    return It(t);
  };
function Wt(t, e) {
  if ((e = new Rt(e)).hasCountry(t)) return e.country(t).countryCallingCode();
  throw new Error("Unknown country: ".concat(t));
}
function Gt(t, e) {
  return void 0 !== e.countries[t];
}
function qt(t) {
  var e = t.version;
  "number" == typeof e ? (this.v1 = 1 === e, this.v2 = 2 === e, this.v3 = 3 === e, this.v4 = 4 === e) : e ? -1 === Et(e, "1.2.0") ? this.v2 = !0 : -1 === Et(e, "1.7.35") ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var Ht = function Ht(t) {
  return "([".concat(St, "]{1,").concat(t, "})");
};
function zt(t) {
  var e = "[  \\t,]*",
    n = "[:\\.．]?[  \\t,-]*",
    r = "#?",
    a = "[  \\t]*";
  return ";ext=" + Ht("20") + "|" + (e + "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)" + n + Ht("20") + r) + "|" + (e + "(?:[xｘ#＃~～]|int|ｉｎｔ)" + n + Ht("9") + r) + "|" + ("[- ]+" + Ht("6") + "#") + "|" + (a + "(?:,{2}|;)" + n + Ht("15") + r) + "|" + (a + "(?:,)+" + n + Ht("9") + r);
}
var Xt = "[" + St + "]{" + wt + "}",
  Yt = "[+＋]{0,1}(?:[" + jt + "]*[" + St + "]){3,}[" + jt + St + "]*",
  Jt = new RegExp("^[+＋]{0,1}(?:[" + jt + "]*[" + St + "]){1,2}$", "i"),
  Kt = Yt + "(?:" + zt() + ")?",
  Zt = new RegExp("^" + Xt + "$|^" + Kt + "$", "i");
var Qt = new RegExp("(?:" + zt() + ")$", "i");
function te(t, e) {
  var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return ee(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === n && t.constructor && (n = t.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(t);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ee(t, e);
  }(t)) || e && t && "number" == typeof t.length) {
    n && (t = n);
    var r = 0;
    return function () {
      return r >= t.length ? {
        done: !0
      } : {
        done: !1,
        value: t[r++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ee(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
var ne = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  "１": "1",
  "２": "2",
  "３": "3",
  "４": "4",
  "５": "5",
  "６": "6",
  "７": "7",
  "８": "8",
  "９": "9",
  "٠": "0",
  "١": "1",
  "٢": "2",
  "٣": "3",
  "٤": "4",
  "٥": "5",
  "٦": "6",
  "٧": "7",
  "٨": "8",
  "٩": "9",
  "۰": "0",
  "۱": "1",
  "۲": "2",
  "۳": "3",
  "۴": "4",
  "۵": "5",
  "۶": "6",
  "۷": "7",
  "۸": "8",
  "۹": "9"
};
function re(t) {
  return ne[t];
}
function ae(t) {
  for (var e, n = "", r = te(t.split("")); !(e = r()).done;) {
    var a = re(e.value);
    a && (n += a);
  }
  return n;
}
function oe(t, e) {
  var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return ie(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === n && t.constructor && (n = t.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(t);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ie(t, e);
  }(t)) || e && t && "number" == typeof t.length) {
    n && (t = n);
    var r = 0;
    return function () {
      return r >= t.length ? {
        done: !0
      } : {
        done: !1,
        value: t[r++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ie(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function ue(t) {
  for (var e, n = "", r = oe(t.split("")); !(e = r()).done;) {
    n += le(e.value, n) || "";
  }
  return n;
}
function le(t, e) {
  if ("+" === t) {
    if (e) return;
    return "+";
  }
  return re(t);
}
function ce(t, e) {
  var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return fe(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === n && t.constructor && (n = t.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(t);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return fe(t, e);
  }(t)) || e && t && "number" == typeof t.length) {
    n && (t = n);
    var r = 0;
    return function () {
      return r >= t.length ? {
        done: !0
      } : {
        done: !1,
        value: t[r++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function fe(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function se(t, e) {
  return ye(t, void 0, e);
}
function ye(t, e, n) {
  var r = n.type(e),
    a = r && r.possibleLengths() || n.possibleLengths();
  if (!a) return "IS_POSSIBLE";
  if ("FIXED_LINE_OR_MOBILE" === e) {
    if (!n.type("FIXED_LINE")) return ye(t, "MOBILE", n);
    var o = n.type("MOBILE");
    o && (a = function (t, e) {
      for (var n, r = t.slice(), a = ce(e); !(n = a()).done;) {
        var o = n.value;
        t.indexOf(o) < 0 && r.push(o);
      }
      return r.sort(function (t, e) {
        return t - e;
      });
    }(a, o.possibleLengths()));
  } else if (e && !r) return "INVALID_LENGTH";
  var i = t.length,
    u = a[0];
  return u === i ? "IS_POSSIBLE" : u > i ? "TOO_SHORT" : a[a.length - 1] < i ? "TOO_LONG" : a.indexOf(i, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function he(t, e) {
  return "IS_POSSIBLE" === se(t, e);
}
function pe(t, e) {
  return t = t || "", new RegExp("^(?:" + e + ")$").test(t);
}
function de(t, e) {
  var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return me(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === n && t.constructor && (n = t.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(t);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return me(t, e);
  }(t)) || e && t && "number" == typeof t.length) {
    n && (t = n);
    var r = 0;
    return function () {
      return r >= t.length ? {
        done: !0
      } : {
        done: !1,
        value: t[r++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function me(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
var ge = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function be(t, e, n) {
  if (e = e || {}, t.country) {
    (n = new Rt(n)).selectNumberingPlan(t.country, t.countryCallingCode);
    var r = e.v2 ? t.nationalNumber : t.phone;
    if (pe(r, n.nationalNumberPattern())) {
      if (ve(r, "FIXED_LINE", n)) return n.type("MOBILE") && "" === n.type("MOBILE").pattern() ? "FIXED_LINE_OR_MOBILE" : n.type("MOBILE") ? ve(r, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE" : "FIXED_LINE_OR_MOBILE";
      for (var a, o = de(ge); !(a = o()).done;) {
        var i = a.value;
        if (ve(r, i, n)) return i;
      }
    }
  }
}
function ve(t, e, n) {
  return !(!(e = n.type(e)) || !e.pattern()) && !(e.possibleLengths() && e.possibleLengths().indexOf(t.length) < 0) && pe(t, e.pattern());
}
function Ce(t, e, n) {
  var r = new Rt(n).getCountryCodesForCallingCode(t);
  return r ? r.filter(function (t) {
    return function (t, e, n) {
      var r = new Rt(n);
      if (r.selectNumberingPlan(e), r.numberingPlan.possibleLengths().indexOf(t.length) >= 0) return !0;
      return !1;
    }(e, t, n);
  }) : [];
}
function Oe(t) {
  return t.replace(new RegExp("[".concat(jt, "]+"), "g"), " ").trim();
}
var Ne = /(\$\d)/;
function we(t, e, n) {
  var r = n.useInternationalFormat,
    a = n.withNationalPrefix;
  n.carrierCode, n.metadata;
  var o = t.replace(new RegExp(e.pattern()), r ? e.internationalFormat() : a && e.nationalPrefixFormattingRule() ? e.format().replace(Ne, e.nationalPrefixFormattingRule()) : e.format());
  return r ? Oe(o) : o;
}
var Pe = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function xe(t, e) {
  var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return Se(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === n && t.constructor && (n = t.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(t);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Se(t, e);
  }(t)) || e && t && "number" == typeof t.length) {
    n && (t = n);
    var r = 0;
    return function () {
      return r >= t.length ? {
        done: !0
      } : {
        done: !1,
        value: t[r++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Se(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function je(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ee(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? je(Object(n), !0).forEach(function (e) {
      Ie(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : je(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
function Ie(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
var ke = {
  formatExtension: function formatExtension(t, e, n) {
    return "".concat(t).concat(n.ext()).concat(e);
  }
};
function Ae(t, e, n, r) {
  if (n = n ? Ee(Ee({}, ke), n) : ke, r = new Rt(r), t.country && "001" !== t.country) {
    if (!r.hasCountry(t.country)) throw new Error("Unknown country: ".concat(t.country));
    r.country(t.country);
  } else {
    if (!t.countryCallingCode) return t.phone || "";
    r.selectNumberingPlan(t.countryCallingCode);
  }
  var a,
    o = r.countryCallingCode(),
    i = n.v2 ? t.nationalNumber : t.phone;
  switch (e) {
    case "NATIONAL":
      return i ? Fe(a = Te(i, t.carrierCode, "NATIONAL", r, n), t.ext, r, n.formatExtension) : "";
    case "INTERNATIONAL":
      return i ? (a = Te(i, null, "INTERNATIONAL", r, n), Fe(a = "+".concat(o, " ").concat(a), t.ext, r, n.formatExtension)) : "+".concat(o);
    case "E.164":
      return "+".concat(o).concat(i);
    case "RFC3966":
      return function (t) {
        var e = t.number,
          n = t.ext;
        if (!e) return "";
        if ("+" !== e[0]) throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
        return "tel:".concat(e).concat(n ? ";ext=" + n : "");
      }({
        number: "+".concat(o).concat(i),
        ext: t.ext
      });
    case "IDD":
      if (!n.fromCountry) return;
      var u = function (t, e, n, r, a) {
        var o = Wt(r, a.metadata);
        if (o === n) {
          var i = Te(t, e, "NATIONAL", a);
          return "1" === n ? n + " " + i : i;
        }
        var u = function (t, e, n) {
          var r = new Rt(n);
          return r.selectNumberingPlan(t, e), r.defaultIDDPrefix() ? r.defaultIDDPrefix() : Pe.test(r.IDDPrefix()) ? r.IDDPrefix() : void 0;
        }(r, void 0, a.metadata);
        if (u) return "".concat(u, " ").concat(n, " ").concat(Te(t, null, "INTERNATIONAL", a));
      }(i, t.carrierCode, o, n.fromCountry, r);
      return Fe(u, t.ext, r, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(e, '"'));
  }
}
function Te(t, e, n, r, a) {
  var o = function (t, e) {
    for (var n, r = xe(t); !(n = r()).done;) {
      var a = n.value;
      if (a.leadingDigitsPatterns().length > 0) {
        var o = a.leadingDigitsPatterns()[a.leadingDigitsPatterns().length - 1];
        if (0 !== e.search(o)) continue;
      }
      if (pe(e, a.pattern())) return a;
    }
  }(r.formats(), t);
  return o ? we(t, o, {
    useInternationalFormat: "INTERNATIONAL" === n,
    withNationalPrefix: !o.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !a || !1 !== a.nationalPrefix,
    carrierCode: e,
    metadata: r
  }) : t;
}
function Fe(t, e, n, r) {
  return e ? r(t, e, n) : t;
}
function De(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Re(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? De(Object(n), !0).forEach(function (e) {
      _e(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : De(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
function _e(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function Me(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
var $e = function () {
    function t(e, n, r) {
      if (function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t), !e) throw new TypeError("`country` or `countryCallingCode` not passed");
      if (!n) throw new TypeError("`nationalNumber` not passed");
      if (!r) throw new TypeError("`metadata` not passed");
      var a = function (t, e) {
          var n,
            r,
            a = new Rt(e);
          Le(t) ? (n = t, a.selectNumberingPlan(n), r = a.countryCallingCode()) : r = t;
          return {
            country: n,
            countryCallingCode: r
          };
        }(e, r),
        o = a.country,
        i = a.countryCallingCode;
      this.country = o, this.countryCallingCode = i, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function () {
        return r;
      };
    }
    var e, n, r;
    return e = t, (n = [{
      key: "setExt",
      value: function value(t) {
        this.ext = t;
      }
    }, {
      key: "getPossibleCountries",
      value: function value() {
        return this.country ? [this.country] : Ce(this.countryCallingCode, this.nationalNumber, this.getMetadata());
      }
    }, {
      key: "isPossible",
      value: function value() {
        return function (t, e, n) {
          if (void 0 === e && (e = {}), n = new Rt(n), e.v2) {
            if (!t.countryCallingCode) throw new Error("Invalid phone number object passed");
            n.selectNumberingPlan(t.countryCallingCode);
          } else {
            if (!t.phone) return !1;
            if (t.country) {
              if (!n.hasCountry(t.country)) throw new Error("Unknown country: ".concat(t.country));
              n.country(t.country);
            } else {
              if (!t.countryCallingCode) throw new Error("Invalid phone number object passed");
              n.selectNumberingPlan(t.countryCallingCode);
            }
          }
          if (n.possibleLengths()) return he(t.phone || t.nationalNumber, n);
          if (t.countryCallingCode && n.isNonGeographicCallingCode(t.countryCallingCode)) return !0;
          throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
        }(this, {
          v2: !0
        }, this.getMetadata());
      }
    }, {
      key: "isValid",
      value: function value() {
        return t = this, e = {
          v2: !0
        }, n = this.getMetadata(), e = e || {}, (n = new Rt(n)).selectNumberingPlan(t.country, t.countryCallingCode), n.hasTypes() ? void 0 !== be(t, e, n.metadata) : pe(e.v2 ? t.nationalNumber : t.phone, n.nationalNumberPattern());
        var t, e, n;
      }
    }, {
      key: "isNonGeographic",
      value: function value() {
        return new Rt(this.getMetadata()).isNonGeographicCallingCode(this.countryCallingCode);
      }
    }, {
      key: "isEqual",
      value: function value(t) {
        return this.number === t.number && this.ext === t.ext;
      }
    }, {
      key: "getType",
      value: function value() {
        return be(this, {
          v2: !0
        }, this.getMetadata());
      }
    }, {
      key: "format",
      value: function value(t, e) {
        return Ae(this, t, e ? Re(Re({}, e), {}, {
          v2: !0
        }) : {
          v2: !0
        }, this.getMetadata());
      }
    }, {
      key: "formatNational",
      value: function value(t) {
        return this.format("NATIONAL", t);
      }
    }, {
      key: "formatInternational",
      value: function value(t) {
        return this.format("INTERNATIONAL", t);
      }
    }, {
      key: "getURI",
      value: function value(t) {
        return this.format("RFC3966", t);
      }
    }]) && Me(e.prototype, n), r && Me(e, r), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t;
  }(),
  Le = function Le(t) {
    return /^[A-Z]{2}$/.test(t);
  };
var Ue = new RegExp("([" + St + "])");
function Be(t, e, n, r) {
  if (e) {
    var a = new Rt(r);
    a.selectNumberingPlan(e, n);
    var o = new RegExp(a.IDDPrefix());
    if (0 === t.search(o)) {
      var i = (t = t.slice(t.match(o)[0].length)).match(Ue);
      if (!(i && null != i[1] && i[1].length > 0 && "0" === i[1])) return t;
    }
  }
}
function Ve(t, e) {
  if (t && e.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + e.numberingPlan.nationalPrefixForParsing() + ")"),
      r = n.exec(t);
    if (r) {
      var a,
        o,
        i,
        u = r.length - 1,
        l = u > 0 && r[u];
      if (e.nationalPrefixTransformRule() && l) a = t.replace(n, e.nationalPrefixTransformRule()), u > 1 && (o = r[1]);else {
        var c = r[0];
        a = t.slice(c.length), l && (o = r[1]);
      }
      if (l) {
        var f = t.indexOf(r[1]);
        t.slice(0, f) === e.numberingPlan.nationalPrefix() && (i = e.numberingPlan.nationalPrefix());
      } else i = r[0];
      return {
        nationalNumber: a,
        nationalPrefix: i,
        carrierCode: o
      };
    }
  }
  return {
    nationalNumber: t
  };
}
function We(t, e) {
  var n = Ve(t, e),
    r = n.carrierCode,
    a = n.nationalNumber;
  if (a !== t) {
    if (!function (t, e, n) {
      if (pe(t, n.nationalNumberPattern()) && !pe(e, n.nationalNumberPattern())) return !1;
      return !0;
    }(t, a, e)) return {
      nationalNumber: t
    };
    if (e.possibleLengths() && !function (t, e) {
      switch (se(t, e)) {
        case "TOO_SHORT":
        case "INVALID_LENGTH":
          return !1;
        default:
          return !0;
      }
    }(a, e)) return {
      nationalNumber: t
    };
  }
  return {
    nationalNumber: a,
    carrierCode: r
  };
}
function Ge(t, e, n, r) {
  var a = e ? Wt(e, r) : n;
  if (0 === t.indexOf(a)) {
    (r = new Rt(r)).selectNumberingPlan(e, n);
    var o = t.slice(a.length),
      i = We(o, r).nationalNumber,
      u = We(t, r).nationalNumber;
    if (!pe(u, r.nationalNumberPattern()) && pe(i, r.nationalNumberPattern()) || "TOO_LONG" === se(u, r)) return {
      countryCallingCode: a,
      number: o
    };
  }
  return {
    number: t
  };
}
function qe(t, e, n, r) {
  if (!t) return {};
  var a;
  if ("+" !== t[0]) {
    var o = Be(t, e, n, r);
    if (!o || o === t) {
      if (e || n) {
        var i = Ge(t, e, n, r),
          u = i.countryCallingCode,
          l = i.number;
        if (u) return {
          countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
          countryCallingCode: u,
          number: l
        };
      }
      return {
        number: t
      };
    }
    a = !0, t = "+" + o;
  }
  if ("0" === t[1]) return {};
  r = new Rt(r);
  for (var c = 2; c - 1 <= xt && c <= t.length;) {
    var f = t.slice(1, c);
    if (r.hasCallingCode(f)) return r.selectNumberingPlan(f), {
      countryCallingCodeSource: a ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
      countryCallingCode: f,
      number: t.slice(c)
    };
    c++;
  }
  return {};
}
function He(t, e) {
  var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return ze(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === n && t.constructor && (n = t.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(t);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ze(t, e);
  }(t)) || e && t && "number" == typeof t.length) {
    n && (t = n);
    var r = 0;
    return function () {
      return r >= t.length ? {
        done: !0
      } : {
        done: !1,
        value: t[r++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ze(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function Xe(t, e) {
  var n = e.countries,
    r = e.defaultCountry,
    a = e.metadata;
  a = new Rt(a);
  for (var o, i = [], u = He(n); !(o = u()).done;) {
    var l = o.value;
    if (a.country(l), a.leadingDigits()) {
      if (t && 0 === t.search(a.leadingDigits())) return l;
    } else if (be({
      phone: t,
      country: l
    }, void 0, a.metadata)) {
      if (!r) return l;
      if (l === r) return l;
      i.push(l);
    }
  }
  if (i.length > 0) return i[0];
}
var Ye = !1;
function Je(t, e) {
  var n = e.nationalNumber,
    r = e.defaultCountry,
    a = e.metadata;
  if (Ye && a.isNonGeographicCallingCode(t)) return "001";
  var o = a.getCountryCodesForCallingCode(t);
  return o ? 1 === o.length ? o[0] : Xe(n, {
    countries: o,
    defaultCountry: r,
    metadata: a.metadata
  }) : void 0;
}
var Ke = "+",
  Ze = "([" + St + "]|[\\-\\.\\(\\)]?)",
  Qe = new RegExp("^\\" + Ke + Ze + "*[" + St + "]" + Ze + "*$", "g"),
  tn = new RegExp("^(" + ("[" + St + "]+((\\-)*[" + St + "])*") + "\\.)*" + ("[a-zA-Z]+((\\-)*[" + St + "])*") + "\\.?$", "g"),
  en = "tel:",
  nn = ";phone-context=",
  rn = ";isub=";
function an(t, e) {
  var n,
    r = e.extractFormattedPhoneNumber,
    a = function (t) {
      var e = t.indexOf(nn);
      if (e < 0) return null;
      var n = e + nn.length;
      if (n >= t.length) return "";
      var r = t.indexOf(";", n);
      return r >= 0 ? t.substring(n, r) : t.substring(n);
    }(t);
  if (!function (t) {
    return null === t || 0 !== t.length && (Qe.test(t) || tn.test(t));
  }(a)) throw new Nt("NOT_A_NUMBER");
  if (null === a) n = r(t) || "";else {
    n = "", a.charAt(0) === Ke && (n += a);
    var o,
      i = t.indexOf(en);
    o = i >= 0 ? i + en.length : 0;
    var u = t.indexOf(nn);
    n += t.substring(o, u);
  }
  var l = n.indexOf(rn);
  if (l > 0 && (n = n.substring(0, l)), "" !== n) return n;
}
var on = 250,
  un = new RegExp("[+＋" + St + "]"),
  ln = new RegExp("[^" + St + "#]+$");
function cn(t, e, n) {
  if (e = e || {}, n = new Rt(n), e.defaultCountry && !n.hasCountry(e.defaultCountry)) {
    if (e.v2) throw new Nt("INVALID_COUNTRY");
    throw new Error("Unknown country: ".concat(e.defaultCountry));
  }
  var r = function (t, e, n) {
      var r = an(t, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(t) {
          return function (t, e, n) {
            if (!t) return;
            if (t.length > on) {
              if (n) throw new Nt("TOO_LONG");
              return;
            }
            if (!1 === e) return t;
            var r = t.search(un);
            if (r < 0) return;
            return t.slice(r).replace(ln, "");
          }(t, n, e);
        }
      });
      if (!r) return {};
      if (!function (t) {
        return t.length >= wt && Zt.test(t);
      }(r)) return function (t) {
        return Jt.test(t);
      }(r) ? {
        error: "TOO_SHORT"
      } : {};
      var a = function (t) {
        var e = t.search(Qt);
        if (e < 0) return {};
        for (var n = t.slice(0, e), r = t.match(Qt), a = 1; a < r.length;) {
          if (r[a]) return {
            number: n,
            ext: r[a]
          };
          a++;
        }
      }(r);
      if (a.ext) return a;
      return {
        number: r
      };
    }(t, e.v2, e.extract),
    a = r.number,
    o = r.ext,
    i = r.error;
  if (!a) {
    if (e.v2) {
      if ("TOO_SHORT" === i) throw new Nt("TOO_SHORT");
      throw new Nt("NOT_A_NUMBER");
    }
    return {};
  }
  var u = function (t, e, n, r) {
      var a,
        o = qe(ue(t), e, n, r.metadata),
        i = o.countryCallingCodeSource,
        u = o.countryCallingCode,
        l = o.number;
      if (u) r.selectNumberingPlan(u);else {
        if (!l || !e && !n) return {};
        r.selectNumberingPlan(e, n), e && (a = e), u = n || Wt(e, r.metadata);
      }
      if (!l) return {
        countryCallingCodeSource: i,
        countryCallingCode: u
      };
      var c = We(ue(l), r),
        f = c.nationalNumber,
        s = c.carrierCode,
        y = Je(u, {
          nationalNumber: f,
          defaultCountry: e,
          metadata: r
        });
      y && (a = y, "001" === y || r.country(a));
      return {
        country: a,
        countryCallingCode: u,
        countryCallingCodeSource: i,
        nationalNumber: f,
        carrierCode: s
      };
    }(a, e.defaultCountry, e.defaultCallingCode, n),
    l = u.country,
    c = u.nationalNumber,
    f = u.countryCallingCode,
    s = u.countryCallingCodeSource,
    y = u.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (e.v2) throw new Nt("INVALID_COUNTRY");
    return {};
  }
  if (!c || c.length < wt) {
    if (e.v2) throw new Nt("TOO_SHORT");
    return {};
  }
  if (c.length > Pt) {
    if (e.v2) throw new Nt("TOO_LONG");
    return {};
  }
  if (e.v2) {
    var h = new $e(f, c, n.metadata);
    return l && (h.country = l), y && (h.carrierCode = y), o && (h.ext = o), h.__countryCallingCodeSource = s, h;
  }
  var p = !!(e.extended ? n.hasSelectedNumberingPlan() : l) && pe(c, n.nationalNumberPattern());
  return e.extended ? {
    country: l,
    countryCallingCode: f,
    carrierCode: y,
    valid: p,
    possible: !!p || !(!0 !== e.extended || !n.possibleLengths() || !he(c, n)),
    phone: c,
    ext: o
  } : p ? function (t, e, n) {
    var r = {
      country: t,
      phone: e
    };
    n && (r.ext = n);
    return r;
  }(l, c, o) : {};
}
function fn(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function sn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? fn(Object(n), !0).forEach(function (e) {
      yn(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : fn(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
function yn(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function hn(t) {
  return hn = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
    return _typeof(t);
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
  }, hn(t);
}
function pn(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function dn(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function mn(t, e) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, e) {
    var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (null == n) return;
    var r,
      a,
      o = [],
      i = !0,
      u = !1;
    try {
      for (n = n.call(t); !(i = (r = n.next()).done) && (o.push(r.value), !e || o.length !== e); i = !0);
    } catch (t) {
      u = !0, a = t;
    } finally {
      try {
        i || null == n.return || n.return();
      } finally {
        if (u) throw a;
      }
    }
    return o;
  }(t, e) || function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return gn(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === n && t.constructor && (n = t.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(t);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return gn(t, e);
  }(t, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function gn(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function bn(t) {
  var e,
    n,
    r,
    a = mn(Array.prototype.slice.call(t), 4),
    o = a[0],
    i = a[1],
    u = a[2],
    l = a[3];
  if ("string" != typeof o) throw new TypeError("A text for parsing must be a string.");
  if (e = o, i && "string" != typeof i) {
    if (!vn(i)) throw new Error("Invalid second argument: ".concat(i));
    u ? (n = i, r = u) : r = i;
  } else l ? (n = u, r = l) : (n = void 0, r = u), i && (n = function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? pn(Object(n), !0).forEach(function (e) {
        dn(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : pn(Object(n)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }
    return t;
  }({
    defaultCountry: i
  }, n));
  return {
    text: e,
    options: n,
    metadata: r
  };
}
var vn = function vn(t) {
  return "object" === hn(t);
};
function Cn(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function On(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? Cn(Object(n), !0).forEach(function (e) {
      Nn(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Cn(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
function Nn(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function wn(t, e, n) {
  e && e.defaultCountry && !Gt(e.defaultCountry, n) && (e = On(On({}, e), {}, {
    defaultCountry: void 0
  }));
  try {
    return function (t, e, n) {
      return cn(t, sn(sn({}, e), {}, {
        v2: !0
      }), n);
    }(t, e, n);
  } catch (t) {
    if (!(t instanceof Nt)) throw t;
  }
}
function Pn() {
  var t = bn(arguments);
  return wn(t.text, t.options, t.metadata);
}
function xn(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Sn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? xn(Object(n), !0).forEach(function (e) {
      jn(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : xn(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
function jn(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function En() {
  var t = bn(arguments),
    e = t.text,
    n = t.options,
    r = t.metadata,
    a = wn(e, n = Sn(Sn({}, n), {}, {
      extract: !1
    }), r);
  return a && a.isValid() || !1;
}
function In(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function kn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? In(Object(n), !0).forEach(function (e) {
      An(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : In(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
function An(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function Tn() {
  var t = bn(arguments),
    e = t.text,
    n = t.options,
    r = t.metadata,
    a = wn(e, n = kn(kn({}, n), {}, {
      extract: !1
    }), r);
  return a && a.isPossible() || !1;
}
function Fn(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
var Dn = function () {
  function t(e) {
    var n = e.onCountryChange,
      r = e.onCallingCodeChange;
    !function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }(this, t), this.onCountryChange = n, this.onCallingCodeChange = r;
  }
  var e, n, r;
  return e = t, (n = [{
    key: "reset",
    value: function value(t) {
      var e = t.country,
        n = t.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(e, n);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function value() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "update",
    value: function value(t) {
      for (var e = 0, n = Object.keys(t); e < n.length; e++) {
        var r = n[e];
        this[r] = t[r];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function value(t, e) {
      this.setCountry(t), this.setCallingCode(e);
    }
  }, {
    key: "setCountry",
    value: function value(t) {
      this.country = t, this.onCountryChange(t);
    }
  }, {
    key: "setCallingCode",
    value: function value(t) {
      this.callingCode = t, this.onCallingCodeChange(t, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function value(t, e) {
      this.international = !0, this.initCountryAndCallingCode(t, e);
    }
  }, {
    key: "appendDigits",
    value: function value(t) {
      this.digits += t;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function value(t) {
      this.nationalSignificantNumber += t;
    }
  }, {
    key: "getNationalDigits",
    value: function value() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function value() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]) && Fn(e.prototype, n), r && Fn(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t;
}();
function Rn(t, e) {
  var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return _n(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === n && t.constructor && (n = t.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(t);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _n(t, e);
  }(t)) || e && t && "number" == typeof t.length) {
    n && (t = n);
    var r = 0;
    return function () {
      return r >= t.length ? {
        done: !0
      } : {
        done: !1,
        value: t[r++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _n(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
var Mn = "x",
  $n = new RegExp(Mn);
function Ln(t, e) {
  if (e < 1) return "";
  for (var n = ""; e > 1;) 1 & e && (n += t), e >>= 1, t += t;
  return n + t;
}
function Un(t, e) {
  return ")" === t[e] && e++, function (t) {
    var e = [],
      n = 0;
    for (; n < t.length;) "(" === t[n] ? e.push(n) : ")" === t[n] && e.pop(), n++;
    var r = 0,
      a = "";
    e.push(t.length);
    for (var o = 0, i = e; o < i.length; o++) {
      var u = i[o];
      a += t.slice(r, u), r = u + 1;
    }
    return a;
  }(t.slice(0, e));
}
function Bn(t, e, n) {
  var r = n.metadata,
    a = n.shouldTryNationalPrefixFormattingRule,
    o = n.getSeparatorAfterNationalPrefix;
  if (new RegExp("^(?:".concat(e.pattern(), ")$")).test(t.nationalSignificantNumber)) return function (t, e, n) {
    var r = n.metadata,
      a = n.shouldTryNationalPrefixFormattingRule,
      o = n.getSeparatorAfterNationalPrefix;
    if (t.nationalSignificantNumber, t.international, t.nationalPrefix, t.carrierCode, a(e)) {
      var i = Vn(t, e, {
        useNationalPrefixFormattingRule: !0,
        getSeparatorAfterNationalPrefix: o,
        metadata: r
      });
      if (i) return i;
    }
    return Vn(t, e, {
      useNationalPrefixFormattingRule: !1,
      getSeparatorAfterNationalPrefix: o,
      metadata: r
    });
  }(t, e, {
    metadata: r,
    shouldTryNationalPrefixFormattingRule: a,
    getSeparatorAfterNationalPrefix: o
  });
}
function Vn(t, e, n) {
  var r = n.metadata,
    a = n.useNationalPrefixFormattingRule,
    o = n.getSeparatorAfterNationalPrefix,
    i = we(t.nationalSignificantNumber, e, {
      carrierCode: t.carrierCode,
      useInternationalFormat: t.international,
      withNationalPrefix: a,
      metadata: r
    });
  if (a || (t.nationalPrefix ? i = t.nationalPrefix + o(e) + i : t.complexPrefixBeforeNationalSignificantNumber && (i = t.complexPrefixBeforeNationalSignificantNumber + " " + i)), function (t, e) {
    return ae(t) === e.getNationalDigits();
  }(i, t)) return i;
}
function Wn(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
var Gn = function () {
  function t() {
    !function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }(this, t);
  }
  var e, n, r;
  return e = t, (n = [{
    key: "parse",
    value: function value(t) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(t), 1 !== this.context.length) throw new Error("Non-finalized contexts left when pattern parse ended");
      var e = this.context[0],
        n = e.branches,
        r = e.instructions;
      if (n) return {
        op: "|",
        args: n.concat([Xn(r)])
      };
      if (0 === r.length) throw new Error("Pattern is required");
      return 1 === r.length ? r[0] : r;
    }
  }, {
    key: "startContext",
    value: function value(t) {
      this.context.push(t);
    }
  }, {
    key: "endContext",
    value: function value() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function value() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function value(t) {
      if (!t) throw new Error("Pattern is required");
      var e = t.match(zn);
      if (e) {
        var n = e[1],
          r = t.slice(0, e.index),
          a = t.slice(e.index + n.length);
        switch (n) {
          case "(?:":
            r && this.parsePattern(r), this.startContext({
              or: !0,
              instructions: [],
              branches: []
            });
            break;
          case ")":
            if (!this.getContext().or) throw new Error('")" operator must be preceded by "(?:" operator');
            if (r && this.parsePattern(r), 0 === this.getContext().instructions.length) throw new Error('No instructions found after "|" operator in an "or" group');
            var o = this.getContext().branches;
            o.push(Xn(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
              op: "|",
              args: o
            });
            break;
          case "|":
            if (!this.getContext().or) throw new Error('"|" operator can only be used inside "or" groups');
            if (r && this.parsePattern(r), !this.getContext().branches) {
              if (1 !== this.context.length) throw new Error('"branches" not found in an "or" group context');
              this.getContext().branches = [];
            }
            this.getContext().branches.push(Xn(this.getContext().instructions)), this.getContext().instructions = [];
            break;
          case "[":
            r && this.parsePattern(r), this.startContext({
              oneOfSet: !0
            });
            break;
          case "]":
            if (!this.getContext().oneOfSet) throw new Error('"]" operator must be preceded by "[" operator');
            this.endContext(), this.getContext().instructions.push({
              op: "[]",
              args: qn(r)
            });
            break;
          default:
            throw new Error("Unknown operator: ".concat(n));
        }
        a && this.parsePattern(a);
      } else {
        if (Hn.test(t)) throw new Error("Illegal characters found in a pattern: ".concat(t));
        this.getContext().instructions = this.getContext().instructions.concat(t.split(""));
      }
    }
  }]) && Wn(e.prototype, n), r && Wn(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t;
}();
function qn(t) {
  for (var e = [], n = 0; n < t.length;) {
    if ("-" === t[n]) {
      if (0 === n || n === t.length - 1) throw new Error("Couldn't parse a one-of set pattern: ".concat(t));
      for (var r = t[n - 1].charCodeAt(0) + 1, a = t[n + 1].charCodeAt(0) - 1, o = r; o <= a;) e.push(String.fromCharCode(o)), o++;
    } else e.push(t[n]);
    n++;
  }
  return e;
}
var Hn = /[\(\)\[\]\?\:\|]/,
  zn = new RegExp("(\\||\\(\\?\\:|\\)|\\[|\\])");
function Xn(t) {
  return 1 === t.length ? t[0] : t;
}
function Yn(t, e) {
  var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return Jn(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === n && t.constructor && (n = t.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(t);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Jn(t, e);
  }(t)) || e && t && "number" == typeof t.length) {
    n && (t = n);
    var r = 0;
    return function () {
      return r >= t.length ? {
        done: !0
      } : {
        done: !1,
        value: t[r++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Jn(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function Kn(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
var Zn = function () {
  function t(e) {
    !function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }(this, t), this.matchTree = new Gn().parse(e);
  }
  var e, n, r;
  return e = t, n = [{
    key: "match",
    value: function value(t) {
      var e = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).allowOverflow;
      if (!t) throw new Error("String is required");
      var n = Qn(t.split(""), this.matchTree, !0);
      if (n && n.match && delete n.matchedChars, !n || !n.overflow || e) return n;
    }
  }], n && Kn(e.prototype, n), r && Kn(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t;
}();
function Qn(t, e, n) {
  if ("string" == typeof e) {
    var r = t.join("");
    return 0 === e.indexOf(r) ? t.length === e.length ? {
      match: !0,
      matchedChars: t
    } : {
      partialMatch: !0
    } : 0 === r.indexOf(e) ? n && t.length > e.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: t.slice(0, e.length)
    } : void 0;
  }
  if (Array.isArray(e)) {
    for (var a = t.slice(), o = 0; o < e.length;) {
      var i = Qn(a, e[o], n && o === e.length - 1);
      if (!i) return;
      if (i.overflow) return i;
      if (!i.match) {
        if (i.partialMatch) return {
          partialMatch: !0
        };
        throw new Error("Unsupported match result:\n".concat(JSON.stringify(i, null, 2)));
      }
      if (0 === (a = a.slice(i.matchedChars.length)).length) return o === e.length - 1 ? {
        match: !0,
        matchedChars: t
      } : {
        partialMatch: !0
      };
      o++;
    }
    return n ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: t.slice(0, t.length - a.length)
    };
  }
  switch (e.op) {
    case "|":
      for (var u, l, c = Yn(e.args); !(l = c()).done;) {
        var f = Qn(t, l.value, n);
        if (f) {
          if (f.overflow) return f;
          if (f.match) return {
            match: !0,
            matchedChars: f.matchedChars
          };
          if (!f.partialMatch) throw new Error("Unsupported match result:\n".concat(JSON.stringify(f, null, 2)));
          u = !0;
        }
      }
      return u ? {
        partialMatch: !0
      } : void 0;
    case "[]":
      for (var s, y = Yn(e.args); !(s = y()).done;) {
        var h = s.value;
        if (t[0] === h) return 1 === t.length ? {
          match: !0,
          matchedChars: t
        } : n ? {
          overflow: !0
        } : {
          match: !0,
          matchedChars: [h]
        };
      }
      return;
    default:
      throw new Error("Unsupported instruction tree: ".concat(e));
  }
}
function tr(t, e) {
  var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return er(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === n && t.constructor && (n = t.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(t);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return er(t, e);
  }(t)) || e && t && "number" == typeof t.length) {
    n && (t = n);
    var r = 0;
    return function () {
      return r >= t.length ? {
        done: !0
      } : {
        done: !1,
        value: t[r++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function er(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function nr(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
var rr = Ln("9", 15),
  ar = /[- ]/,
  or = new RegExp("[" + jt + "]*\\$1[" + jt + "]*(\\$\\d[" + jt + "]*)*$"),
  ir = function () {
    function t(e) {
      e.state;
      var n = e.metadata;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t), this.metadata = n, this.resetFormat();
    }
    var e, n, r;
    return e = t, n = [{
      key: "resetFormat",
      value: function value() {
        this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
      }
    }, {
      key: "reset",
      value: function value(t, e) {
        this.resetFormat(), t ? (this.isNANP = "1" === t.callingCode(), this.matchingFormats = t.formats(), e.nationalSignificantNumber && this.narrowDownMatchingFormats(e)) : (this.isNANP = void 0, this.matchingFormats = []);
      }
    }, {
      key: "format",
      value: function value(t, e) {
        var n,
          r,
          a = this;
        if (n = e.nationalSignificantNumber, r = this.metadata, "IS_POSSIBLE" === se(n, r)) for (var o, i = tr(this.matchingFormats); !(o = i()).done;) {
          var u = o.value,
            l = Bn(e, u, {
              metadata: this.metadata,
              shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(t) {
                return a.shouldTryNationalPrefixFormattingRule(t, {
                  international: e.international,
                  nationalPrefix: e.nationalPrefix
                });
              },
              getSeparatorAfterNationalPrefix: function getSeparatorAfterNationalPrefix(t) {
                return a.getSeparatorAfterNationalPrefix(t);
              }
            });
          if (l) return this.resetFormat(), this.chosenFormat = u, this.setNationalNumberTemplate(l.replace(/\d/g, Mn), e), this.populatedNationalNumberTemplate = l, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(Mn), l;
        }
        return this.formatNationalNumberWithNextDigits(t, e);
      }
    }, {
      key: "formatNationalNumberWithNextDigits",
      value: function value(t, e) {
        var n = this.chosenFormat,
          r = this.chooseFormat(e);
        if (r) return r === n ? this.formatNextNationalNumberDigits(t) : this.formatNextNationalNumberDigits(e.getNationalDigits());
      }
    }, {
      key: "narrowDownMatchingFormats",
      value: function value(t) {
        var e = this,
          n = t.nationalSignificantNumber,
          r = t.nationalPrefix,
          a = t.international,
          o = n,
          i = o.length - 3;
        i < 0 && (i = 0), this.matchingFormats = this.matchingFormats.filter(function (t) {
          return e.formatSuits(t, a, r) && e.formatMatches(t, o, i);
        }), this.chosenFormat && -1 === this.matchingFormats.indexOf(this.chosenFormat) && this.resetFormat();
      }
    }, {
      key: "formatSuits",
      value: function value(t, e, n) {
        return !(n && !t.usesNationalPrefix() && !t.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !e && !n && t.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
      }
    }, {
      key: "formatMatches",
      value: function value(t, e, n) {
        var r = t.leadingDigitsPatterns().length;
        if (0 === r) return !0;
        n = Math.min(n, r - 1);
        var a = t.leadingDigitsPatterns()[n];
        if (e.length < 3) try {
          return void 0 !== new Zn(a).match(e, {
            allowOverflow: !0
          });
        } catch (t) {
          return console.error(t), !0;
        }
        return new RegExp("^(".concat(a, ")")).test(e);
      }
    }, {
      key: "getFormatFormat",
      value: function value(t, e) {
        return e ? t.internationalFormat() : t.format();
      }
    }, {
      key: "chooseFormat",
      value: function value(t) {
        for (var e, n = this, r = function r() {
            var r = e.value;
            return n.chosenFormat === r ? "break" : or.test(n.getFormatFormat(r, t.international)) ? n.createTemplateForFormat(r, t) ? (n.chosenFormat = r, "break") : (n.matchingFormats = n.matchingFormats.filter(function (t) {
              return t !== r;
            }), "continue") : "continue";
          }, a = tr(this.matchingFormats.slice()); !(e = a()).done;) {
          var o = r();
          if ("break" === o) break;
        }
        return this.chosenFormat || this.resetFormat(), this.chosenFormat;
      }
    }, {
      key: "createTemplateForFormat",
      value: function value(t, e) {
        if (!(t.pattern().indexOf("|") >= 0)) {
          var n = this.getTemplateForFormat(t, e);
          return n ? (this.setNationalNumberTemplate(n, e), !0) : void 0;
        }
      }
    }, {
      key: "getSeparatorAfterNationalPrefix",
      value: function value(t) {
        return this.isNANP || t && t.nationalPrefixFormattingRule() && ar.test(t.nationalPrefixFormattingRule()) ? " " : "";
      }
    }, {
      key: "getInternationalPrefixBeforeCountryCallingCode",
      value: function value(t, e) {
        var n = t.IDDPrefix,
          r = t.missingPlus;
        return n ? e && !1 === e.spacing ? n : n + " " : r ? "" : "+";
      }
    }, {
      key: "getTemplate",
      value: function value(t) {
        if (this.template) {
          for (var e = -1, n = 0, r = t.international ? this.getInternationalPrefixBeforeCountryCallingCode(t, {
              spacing: !1
            }) : ""; n < r.length + t.getDigitsWithoutInternationalPrefix().length;) e = this.template.indexOf(Mn, e + 1), n++;
          return Un(this.template, e + 1);
        }
      }
    }, {
      key: "setNationalNumberTemplate",
      value: function value(t, e) {
        this.nationalNumberTemplate = t, this.populatedNationalNumberTemplate = t, this.populatedNationalNumberTemplatePosition = -1, e.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(e).replace(/[\d\+]/g, Mn) + Ln(Mn, e.callingCode.length) + " " + t : this.template = t;
      }
    }, {
      key: "getTemplateForFormat",
      value: function value(t, e) {
        var n = e.nationalSignificantNumber,
          r = e.international,
          a = e.nationalPrefix,
          o = e.complexPrefixBeforeNationalSignificantNumber,
          i = t.pattern();
        i = i.replace(/\[([^\[\]])*\]/g, "\\d").replace(/\d(?=[^,}][^,}])/g, "\\d");
        var u = rr.match(i)[0];
        if (!(n.length > u.length)) {
          var l = new RegExp("^" + i + "$"),
            c = n.replace(/\d/g, "9");
          l.test(c) && (u = c);
          var f,
            s = this.getFormatFormat(t, r);
          if (this.shouldTryNationalPrefixFormattingRule(t, {
            international: r,
            nationalPrefix: a
          })) {
            var y = s.replace(Ne, t.nationalPrefixFormattingRule());
            if (ae(t.nationalPrefixFormattingRule()) === (a || "") + ae("$1") && (s = y, f = !0, a)) for (var h = a.length; h > 0;) s = s.replace(/\d/, Mn), h--;
          }
          var p = u.replace(new RegExp(i), s).replace(new RegExp("9", "g"), Mn);
          return f || (o ? p = Ln(Mn, o.length) + " " + p : a && (p = Ln(Mn, a.length) + this.getSeparatorAfterNationalPrefix(t) + p)), r && (p = Oe(p)), p;
        }
      }
    }, {
      key: "formatNextNationalNumberDigits",
      value: function value(t) {
        var e = function (t, e, n) {
          for (var r, a = Rn(n.split("")); !(r = a()).done;) {
            var o = r.value;
            if (t.slice(e + 1).search($n) < 0) return;
            e = t.search($n), t = t.replace($n, o);
          }
          return [t, e];
        }(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, t);
        if (e) return this.populatedNationalNumberTemplate = e[0], this.populatedNationalNumberTemplatePosition = e[1], Un(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
        this.resetFormat();
      }
    }, {
      key: "shouldTryNationalPrefixFormattingRule",
      value: function value(t, e) {
        var n = e.international,
          r = e.nationalPrefix;
        if (t.nationalPrefixFormattingRule()) {
          var a = t.usesNationalPrefix();
          if (a && r || !a && !n) return !0;
        }
      }
    }], n && nr(e.prototype, n), r && nr(e, r), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t;
  }();
function ur(t, e) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, e) {
    var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (null == n) return;
    var r,
      a,
      o = [],
      i = !0,
      u = !1;
    try {
      for (n = n.call(t); !(i = (r = n.next()).done) && (o.push(r.value), !e || o.length !== e); i = !0);
    } catch (t) {
      u = !0, a = t;
    } finally {
      try {
        i || null == n.return || n.return();
      } finally {
        if (u) throw a;
      }
    }
    return o;
  }(t, e) || function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return lr(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === n && t.constructor && (n = t.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(t);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return lr(t, e);
  }(t, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function lr(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function cr(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
var fr = new RegExp("^" + ("[" + jt + St + "]+") + "$", "i"),
  sr = "(?:[+＋][" + jt + St + "]*|[" + jt + St + "]+)",
  yr = new RegExp("[^" + jt + St + "]+.*$"),
  hr = /[^\d\[\]]/,
  pr = function () {
    function t(e) {
      var n = e.defaultCountry,
        r = e.defaultCallingCode,
        a = e.metadata,
        o = e.onNationalSignificantNumberChange;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t), this.defaultCountry = n, this.defaultCallingCode = r, this.metadata = a, this.onNationalSignificantNumberChange = o;
    }
    var e, n, r;
    return e = t, (n = [{
      key: "input",
      value: function value(t, e) {
        var n,
          r = function (t) {
            var e = function (t) {
                var e = function (t) {
                  var e,
                    n = t.search(sr);
                  if (!(n < 0)) return "+" === (t = t.slice(n))[0] && (e = !0, t = t.slice(1)), t = t.replace(yr, ""), e && (t = "+" + t), t;
                }(t) || "";
                return "+" === e[0] ? [e.slice(1), !0] : [e];
              }(t),
              n = ur(e, 2),
              r = n[0],
              a = n[1];
            return fr.test(r) || (r = ""), [r, a];
          }(t),
          a = ur(r, 2),
          o = a[0],
          i = a[1],
          u = ae(o);
        return i && (e.digits || (e.startInternationalNumber(), u || (n = !0))), u && this.inputDigits(u, e), {
          digits: u,
          justLeadingPlus: n
        };
      }
    }, {
      key: "inputDigits",
      value: function value(t, e) {
        var n = e.digits,
          r = n.length < 3 && n.length + t.length >= 3;
        if (e.appendDigits(t), r && this.extractIddPrefix(e), this.isWaitingForCountryCallingCode(e)) {
          if (!this.extractCountryCallingCode(e)) return;
        } else e.appendNationalSignificantNumberDigits(t);
        e.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(e.getNationalDigits(), function (t) {
          return e.update(t);
        });
      }
    }, {
      key: "isWaitingForCountryCallingCode",
      value: function value(t) {
        var e = t.international,
          n = t.callingCode;
        return e && !n;
      }
    }, {
      key: "extractCountryCallingCode",
      value: function value(t) {
        var e = qe("+" + t.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
          n = e.countryCallingCode,
          r = e.number;
        if (n) return t.setCallingCode(n), t.update({
          nationalSignificantNumber: r
        }), !0;
      }
    }, {
      key: "reset",
      value: function value(t) {
        if (t) {
          this.hasSelectedNumberingPlan = !0;
          var e = t._nationalPrefixForParsing();
          this.couldPossiblyExtractAnotherNationalSignificantNumber = e && hr.test(e);
        } else this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
      }
    }, {
      key: "extractNationalSignificantNumber",
      value: function value(t, e) {
        if (this.hasSelectedNumberingPlan) {
          var n = Ve(t, this.metadata),
            r = n.nationalPrefix,
            a = n.nationalNumber,
            o = n.carrierCode;
          if (a !== t) return this.onExtractedNationalNumber(r, o, a, t, e), !0;
        }
      }
    }, {
      key: "extractAnotherNationalSignificantNumber",
      value: function value(t, e, n) {
        if (!this.hasExtractedNationalSignificantNumber) return this.extractNationalSignificantNumber(t, n);
        if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
          var r = Ve(t, this.metadata),
            a = r.nationalPrefix,
            o = r.nationalNumber,
            i = r.carrierCode;
          if (o !== e) return this.onExtractedNationalNumber(a, i, o, t, n), !0;
        }
      }
    }, {
      key: "onExtractedNationalNumber",
      value: function value(t, e, n, r, a) {
        var o,
          i,
          u = r.lastIndexOf(n);
        if (u >= 0 && u === r.length - n.length) {
          i = !0;
          var l = r.slice(0, u);
          l !== t && (o = l);
        }
        a({
          nationalPrefix: t,
          carrierCode: e,
          nationalSignificantNumber: n,
          nationalSignificantNumberMatchesInput: i,
          complexPrefixBeforeNationalSignificantNumber: o
        }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
      }
    }, {
      key: "reExtractNationalSignificantNumber",
      value: function value(t) {
        return !!this.extractAnotherNationalSignificantNumber(t.getNationalDigits(), t.nationalSignificantNumber, function (e) {
          return t.update(e);
        }) || (this.extractIddPrefix(t) || this.fixMissingPlus(t) ? (this.extractCallingCodeAndNationalSignificantNumber(t), !0) : void 0);
      }
    }, {
      key: "extractIddPrefix",
      value: function value(t) {
        var e = t.international,
          n = t.IDDPrefix,
          r = t.digits;
        if (t.nationalSignificantNumber, !e && !n) {
          var a = Be(r, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
          return void 0 !== a && a !== r ? (t.update({
            IDDPrefix: r.slice(0, r.length - a.length)
          }), this.startInternationalNumber(t, {
            country: void 0,
            callingCode: void 0
          }), !0) : void 0;
        }
      }
    }, {
      key: "fixMissingPlus",
      value: function value(t) {
        if (!t.international) {
          var e = Ge(t.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
            n = e.countryCallingCode;
          if (e.number, n) return t.update({
            missingPlus: !0
          }), this.startInternationalNumber(t, {
            country: t.country,
            callingCode: n
          }), !0;
        }
      }
    }, {
      key: "startInternationalNumber",
      value: function value(t, e) {
        var n = e.country,
          r = e.callingCode;
        t.startInternationalNumber(n, r), t.nationalSignificantNumber && (t.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
      }
    }, {
      key: "extractCallingCodeAndNationalSignificantNumber",
      value: function value(t) {
        this.extractCountryCallingCode(t) && this.extractNationalSignificantNumber(t.getNationalDigits(), function (e) {
          return t.update(e);
        });
      }
    }]) && cr(e.prototype, n), r && cr(e, r), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t;
  }();
function dr(t) {
  return dr = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
    return _typeof(t);
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
  }, dr(t);
}
function mr(t, e) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, e) {
    var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (null == n) return;
    var r,
      a,
      o = [],
      i = !0,
      u = !1;
    try {
      for (n = n.call(t); !(i = (r = n.next()).done) && (o.push(r.value), !e || o.length !== e); i = !0);
    } catch (t) {
      u = !0, a = t;
    } finally {
      try {
        i || null == n.return || n.return();
      } finally {
        if (u) throw a;
      }
    }
    return o;
  }(t, e) || function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return gr(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === n && t.constructor && (n = t.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(t);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return gr(t, e);
  }(t, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function gr(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function br(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
var vr = function () {
  function t(e, n) {
    !function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }(this, t), this.metadata = new Rt(n);
    var r = mr(this.getCountryAndCallingCode(e), 2),
      a = r[0],
      o = r[1];
    this.defaultCountry = a, this.defaultCallingCode = o, this.reset();
  }
  var e, n, r;
  return e = t, (n = [{
    key: "getCountryAndCallingCode",
    value: function value(t) {
      var e, n;
      return t && ("object" === dr(t) ? (e = t.defaultCountry, n = t.defaultCallingCode) : e = t), e && !this.metadata.hasCountry(e) && (e = void 0), [e, n];
    }
  }, {
    key: "input",
    value: function value(t) {
      var e = this.parser.input(t, this.state),
        n = e.digits;
      if (e.justLeadingPlus) this.formattedOutput = "+";else if (n) {
        var r;
        if (this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state), this.metadata.hasSelectedNumberingPlan() && (r = this.formatter.format(n, this.state)), void 0 === r && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var a = this.state.getNationalDigits();
          a && (r = this.formatter.format(a, this.state));
        }
        this.formattedOutput = r ? this.getFullNumber(r) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function value() {
      var t = this;
      return this.state = new Dn({
        onCountryChange: function onCountryChange(e) {
          t.country = e;
        },
        onCallingCodeChange: function onCallingCodeChange(e, n) {
          t.metadata.selectNumberingPlan(n, e), t.formatter.reset(t.metadata.numberingPlan, t.state), t.parser.reset(t.metadata.numberingPlan);
        }
      }), this.formatter = new ir({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new pr({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
          t.determineTheCountryIfNeeded(), t.formatter.reset(t.metadata.numberingPlan, t.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
  }, {
    key: "isInternational",
    value: function value() {
      return this.state.international;
    }
  }, {
    key: "getCallingCode",
    value: function value() {
      if (this.isInternational()) return this.state.callingCode;
    }
  }, {
    key: "getCountryCallingCode",
    value: function value() {
      return this.getCallingCode();
    }
  }, {
    key: "getCountry",
    value: function value() {
      if (this.state.digits) return this._getCountry();
    }
  }, {
    key: "_getCountry",
    value: function value() {
      return this.state.country;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function value() {
      this.state.country && !this.isCountryCallingCodeAmbiguous() || this.determineTheCountry();
    }
  }, {
    key: "getFullNumber",
    value: function value(t) {
      var e = this;
      if (this.isInternational()) {
        var n = function n(t) {
            return e.formatter.getInternationalPrefixBeforeCountryCallingCode(e.state, {
              spacing: !!t
            }) + t;
          },
          r = this.state.callingCode;
        return n(r ? t ? "".concat(r, " ").concat(t) : r : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return t;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function value() {
      var t = this.state,
        e = t.nationalSignificantNumber,
        n = t.complexPrefixBeforeNationalSignificantNumber,
        r = t.nationalPrefix,
        a = e,
        o = n || r;
      return o && (a = o + a), a;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function value() {
      var t = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(t ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function value() {
      var t = this.getNonFormattedNumber();
      if (t) return t.replace(/[\+\d]/g, Mn);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function value() {
      var t = this.state.callingCode,
        e = this.metadata.getCountryCodesForCallingCode(t);
      return e && e.length > 1;
    }
  }, {
    key: "determineTheCountry",
    value: function value() {
      this.state.setCountry(Je(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
  }, {
    key: "getNumberValue",
    value: function value() {
      var t = this.state,
        e = t.digits,
        n = t.callingCode,
        r = t.country,
        a = t.nationalSignificantNumber;
      if (e) return this.isInternational() ? n ? "+" + n + a : "+" + e : r || n ? "+" + (r ? this.metadata.countryCallingCode() : n) + a : void 0;
    }
  }, {
    key: "getNumber",
    value: function value() {
      var t = this.state,
        e = t.nationalSignificantNumber,
        n = t.carrierCode,
        r = t.callingCode,
        a = this._getCountry();
      if (e && (a || r)) {
        if (a && a === this.defaultCountry) {
          var o = new Rt(this.metadata.metadata);
          o.selectNumberingPlan(a);
          var i = o.numberingPlan.callingCode(),
            u = this.metadata.getCountryCodesForCallingCode(i);
          if (u.length > 1) {
            var l = Xe(e, {
              countries: u,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });
            l && (a = l);
          }
        }
        var c = new $e(a || r, e, this.metadata.metadata);
        return n && (c.carrierCode = n), c;
      }
    }
  }, {
    key: "isPossible",
    value: function value() {
      var t = this.getNumber();
      return !!t && t.isPossible();
    }
  }, {
    key: "isValid",
    value: function value() {
      var t = this.getNumber();
      return !!t && t.isValid();
    }
  }, {
    key: "getNationalNumber",
    value: function value() {
      return this.state.nationalSignificantNumber;
    }
  }, {
    key: "getChars",
    value: function value() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
  }, {
    key: "getTemplate",
    value: function value() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]) && br(e.prototype, n), r && br(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t;
}();
function Cr(t) {
  return new Rt(t).getCountries();
}
function Or(t) {
  var e = t.country,
    n = t.international,
    r = t.withCountryCallingCode,
    a = t.metadata;
  return e && n && !r ? "+".concat(Wt(e, a)) : "";
}
function Nr(t, e) {
  return e && " " === (t = t.slice(e.length))[0] && (t = t.slice(1)), t;
}
var wr = ["country", "international", "withCountryCallingCode", "metadata"];
function Pr() {
  return Pr = Object.assign ? Object.assign.bind() : function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Pr.apply(this, arguments);
}
function xr(t, e) {
  if (null == t) return {};
  var n,
    r,
    a = function (t, e) {
      if (null == t) return {};
      var n,
        r,
        a = {},
        o = Object.keys(t);
      for (r = 0; r < o.length; r++) n = o[r], e.indexOf(n) >= 0 || (a[n] = t[n]);
      return a;
    }(t, e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (r = 0; r < o.length; r++) n = o[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (a[n] = t[n]);
  }
  return a;
}
var Sr = function (e) {
    function r(r, a) {
      var o = r.country,
        i = r.international,
        u = r.withCountryCallingCode,
        l = r.metadata,
        c = void 0 === l ? e : l,
        f = xr(r, wr),
        s = n(function (t) {
          var e = new vr(o, c),
            n = Or({
              country: o,
              international: i,
              withCountryCallingCode: u,
              metadata: c
            }),
            r = e.input(n + t),
            a = e.getTemplate();
          return n && (r = Nr(r, n), a && (a = Nr(a, n))), {
            text: r,
            template: a
          };
        }, [o, c]);
      return /*#__PURE__*/t.createElement(st, Pr({}, f, {
        ref: a,
        parse: le,
        format: s
      }));
    }
    return (r = /*#__PURE__*/t.forwardRef(r)).propTypes = {
      value: Y.string.isRequired,
      onChange: Y.func.isRequired,
      country: Y.string,
      international: Y.bool,
      withCountryCallingCode: Y.bool,
      metadata: Y.object
    }, r;
  }(),
  jr = ["value", "onChange", "country", "international", "withCountryCallingCode", "metadata", "inputComponent"];
function Er() {
  return Er = Object.assign ? Object.assign.bind() : function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Er.apply(this, arguments);
}
function Ir(t, e) {
  if (null == t) return {};
  var n,
    r,
    a = function (t, e) {
      if (null == t) return {};
      var n,
        r,
        a = {},
        o = Object.keys(t);
      for (r = 0; r < o.length; r++) n = o[r], e.indexOf(n) >= 0 || (a[n] = t[n]);
      return a;
    }(t, e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (r = 0; r < o.length; r++) n = o[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (a[n] = t[n]);
  }
  return a;
}
var kr = function (e) {
  function r(r, a) {
    var o = r.value,
      i = r.onChange,
      u = r.country,
      l = r.international,
      c = r.withCountryCallingCode,
      f = r.metadata,
      s = void 0 === f ? e : f,
      y = r.inputComponent,
      h = void 0 === y ? "input" : y,
      p = Ir(r, jr),
      d = Or({
        country: u,
        international: l,
        withCountryCallingCode: c,
        metadata: s
      }),
      m = n(function (t) {
        var e = ue(t.target.value);
        e === o && 0 === Ar(d, e, u, s).indexOf(t.target.value) && (e = e.slice(0, -1));
        i(e);
      }, [d, o, i, u, s]);
    return /*#__PURE__*/t.createElement(h, Er({}, p, {
      ref: a,
      value: Ar(d, o, u, s),
      onChange: m
    }));
  }
  return (r = /*#__PURE__*/t.forwardRef(r)).propTypes = {
    value: Y.string.isRequired,
    onChange: Y.func.isRequired,
    country: Y.string,
    international: Y.bool,
    withCountryCallingCode: Y.bool,
    metadata: Y.object,
    inputComponent: Y.elementType
  }, r;
}();
function Ar(t, e, n, r) {
  return Nr(function (t, e, n) {
    return n || (n = e, e = void 0), new vr(e, n).input(t);
  }(t + e, n, r), t);
}
function Tr(t, e) {
  return "+" + Wt(t, e);
}
function Fr(t) {
  return Fr = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
    return _typeof(t);
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
  }, Fr(t);
}
function Dr(t, e, n) {
  if (n || "object" === Fr(e) && (n = e, e = "NATIONAL"), !t) return "";
  var r = Pn(t, n);
  if (!r) return "";
  switch (e) {
    case "National":
      e = "NATIONAL";
      break;
    case "International":
      e = "INTERNATIONAL";
  }
  return r.format(e);
}
function Rr(t, e) {
  return Dr(t, "INTERNATIONAL", e);
}
function _r(t, e) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, e) {
    var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (null != n) {
      var r,
        a,
        o,
        i,
        u = [],
        l = !0,
        c = !1;
      try {
        if (o = (n = n.call(t)).next, 0 === e) {
          if (Object(n) !== n) return;
          l = !1;
        } else for (; !(l = (r = o.call(n)).done) && (u.push(r.value), u.length !== e); l = !0);
      } catch (t) {
        c = !0, a = t;
      } finally {
        try {
          if (!l && null != n.return && (i = n.return(), Object(i) !== i)) return;
        } finally {
          if (c) throw a;
        }
      }
      return u;
    }
  }(t, e) || function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return Mr(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === n && t.constructor && (n = t.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(t);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Mr(t, e);
  }(t, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function Mr(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function $r(t) {
  var o = this,
    i = t.value,
    u = t.onChange,
    l = t.country,
    c = t.defaultCountry,
    f = t.international,
    s = t.withCountryCallingCode,
    y = t.useNationalFormatForDefaultCountryValue,
    h = t.metadata,
    p = e(),
    d = function d(t, e, n) {
      console.error("[react-phone-number-input] Expected phone number ".concat(t, " to correspond to country ").concat(e, " but ").concat(n ? "in reality it corresponds to country " + n : "it doesn't", ".")), p.current = !0;
    },
    m = function m(t) {
      return function (t, e, n, r, a, o, i, u) {
        if (e && n && r) {
          var l = Tr(e, i);
          return t ? (0 !== t.indexOf(l) && u(t, e), t) : l;
        }
        if (!t) return "";
        if (!e && !a) return t;
        var c = new vr(void 0, i);
        c.input(t);
        var f = c.getNumber();
        return f ? e ? (f.country && f.country !== e ? u(t, e, f.country) : f.countryCallingCode !== Wt(e, i) && u(t, e), n ? f.nationalNumber : ae(f.formatNational())) : f.countryCallingCode && f.countryCallingCode === Wt(a, i) && o ? ae(f.formatNational()) : t : "";
      }(i, l, f, s, c, y, h, function () {
        t && t.onCountryMismatch && t.onCountryMismatch();
        for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
        d.apply(o, n);
      });
    },
    g = _r(r(l), 2),
    b = g[0],
    v = g[1],
    C = _r(r(c), 2),
    O = C[0],
    N = C[1],
    w = _r(r(m()), 2),
    P = w[0],
    x = w[1],
    S = _r(r(i), 2),
    j = S[0],
    E = S[1],
    I = _r(r(), 2);
  I[0];
  var k = I[1],
    A = n(function () {
      return k({});
    }, [k]);
  function T(t) {
    if (t) {
      l && f && !s && (t = "+".concat(Wt(l, h)).concat(t));
      var e = new vr(l || c, h);
      return e.input(t), e.getNumberValue();
    }
  }
  a(function () {
    i !== j && (E(i), x(m()));
  }, [i]), a(function () {
    if (l !== b) {
      var t;
      v(l);
      var e = m({
        onCountryMismatch: function onCountryMismatch() {
          t = !0;
        }
      });
      x(e), t && E(T(e));
    }
  }, [l]), a(function () {
    c !== O && (N(c), x(m()));
  }, [c]), a(function () {
    j !== i && u(j);
  }, [j]);
  var F = n(function (t) {
    var e;
    if (l) {
      if (f && s) {
        var n = Tr(l, h);
        if (0 !== t.indexOf(n)) if (t && "+" !== t[0]) t = n + t;else if (!p.current) return x(n), E(void 0), A();
      } else t && "+" === t[0] && (t = t.slice(1));
    } else c || t && "+" !== t[0] && (t = "+" + t);
    t && (e = T(t)), x(t), E(e);
  }, [l, f, s, c, h, x, E, A, p]);
  return [P, F];
}
var Lr = ["Component", "country", "defaultCountry", "useNationalFormatForDefaultCountryValue", "value", "onChange", "metadata", "international", "withCountryCallingCode"];
function Ur() {
  return Ur = Object.assign ? Object.assign.bind() : function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Ur.apply(this, arguments);
}
function Br(t, e) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, e) {
    var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (null != n) {
      var r,
        a,
        o,
        i,
        u = [],
        l = !0,
        c = !1;
      try {
        if (o = (n = n.call(t)).next, 0 === e) {
          if (Object(n) !== n) return;
          l = !1;
        } else for (; !(l = (r = o.call(n)).done) && (u.push(r.value), u.length !== e); l = !0);
      } catch (t) {
        c = !0, a = t;
      } finally {
        try {
          if (!l && null != n.return && (i = n.return(), Object(i) !== i)) return;
        } finally {
          if (c) throw a;
        }
      }
      return u;
    }
  }(t, e) || function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return Vr(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === n && t.constructor && (n = t.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(t);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Vr(t, e);
  }(t, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function Vr(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function Wr(t, e) {
  if (null == t) return {};
  var n,
    r,
    a = function (t, e) {
      if (null == t) return {};
      var n,
        r,
        a = {},
        o = Object.keys(t);
      for (r = 0; r < o.length; r++) n = o[r], e.indexOf(n) >= 0 || (a[n] = t[n]);
      return a;
    }(t, e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (r = 0; r < o.length; r++) n = o[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (a[n] = t[n]);
  }
  return a;
}
function Gr(e, n) {
  var r = e.Component,
    a = e.country,
    o = e.defaultCountry,
    i = e.useNationalFormatForDefaultCountryValue,
    u = void 0 === i || i,
    l = e.value,
    c = e.onChange,
    f = e.metadata,
    s = e.international,
    y = e.withCountryCallingCode,
    h = Wr(e, Lr),
    p = Br($r({
      value: l,
      onChange: c,
      country: a,
      defaultCountry: o,
      international: s,
      withCountryCallingCode: y,
      useNationalFormatForDefaultCountryValue: u,
      metadata: f
    }), 2),
    d = p[0],
    m = p[1];
  return /*#__PURE__*/t.createElement(r, Ur({}, h, {
    ref: n,
    metadata: f,
    international: s,
    withCountryCallingCode: y,
    country: a || o,
    value: d,
    onChange: m
  }));
}
(Gr = /*#__PURE__*/t.forwardRef(Gr)).propTypes = {
  value: Y.string,
  onChange: Y.func.isRequired,
  country: Y.string,
  defaultCountry: Y.string,
  international: Y.bool,
  withCountryCallingCode: Y.bool,
  Component: Y.elementType.isRequired,
  useNationalFormatForDefaultCountryValue: Y.bool,
  metadata: Y.object.isRequired
};
var qr = Gr,
  Hr = ["type", "autoComplete", "smartCaret", "metadata"];
function zr() {
  return zr = Object.assign ? Object.assign.bind() : function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, zr.apply(this, arguments);
}
function Xr(t, e) {
  if (null == t) return {};
  var n,
    r,
    a = function (t, e) {
      if (null == t) return {};
      var n,
        r,
        a = {},
        o = Object.keys(t);
      for (r = 0; r < o.length; r++) n = o[r], e.indexOf(n) >= 0 || (a[n] = t[n]);
      return a;
    }(t, e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (r = 0; r < o.length; r++) n = o[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (a[n] = t[n]);
  }
  return a;
}
function Yr(e) {
  function n(n, r) {
    var a = n.type,
      o = void 0 === a ? "tel" : a,
      i = n.autoComplete,
      u = void 0 === i ? "tel" : i,
      l = n.smartCaret,
      c = void 0 === l || l,
      f = n.metadata,
      s = void 0 === f ? e : f,
      y = Xr(n, Hr);
    return /*#__PURE__*/t.createElement(qr, zr({}, y, {
      type: o,
      autoComplete: u,
      metadata: s,
      ref: r,
      Component: c ? Sr : kr
    }));
  }
  return (n = /*#__PURE__*/t.forwardRef(n)).propTypes = {
    type: Y.string,
    autoComplete: Y.string,
    smartCaret: Y.bool,
    metadata: Y.object
  }, n;
}
Yr();
var Jr = function Jr(t) {
  function e(e, n) {
    var r = Array.prototype.slice.call(n);
    return r.push(t), e.apply(this, r);
  }
  var n = {
      parsePhoneNumber: function parsePhoneNumber() {
        return e(Pn, arguments);
      },
      formatPhoneNumber: function formatPhoneNumber() {
        return e(Dr, arguments);
      },
      formatPhoneNumberIntl: function formatPhoneNumberIntl() {
        return e(Rr, arguments);
      },
      isValidPhoneNumber: function isValidPhoneNumber() {
        return e(En, arguments);
      },
      isPossiblePhoneNumber: function isPossiblePhoneNumber() {
        return e(Tn, arguments);
      },
      getCountries: function getCountries() {
        return e(Cr, arguments);
      },
      getCountryCallingCode: function getCountryCallingCode() {
        return e(Wt, arguments);
      },
      isSupportedCountry: function isSupportedCountry() {
        return e(Gt, arguments);
      }
    },
    r = Yr(t);
  return Object.assign(r, n), r;
};
export { Jr as createInput };